import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import {
  IFileExport,
  IGetNotificationCount,
  IGetNotificationFollowUps,
  IGetNotificationScheduledMove, IGetNotificationUnitsLocked, IRemoveResponse, IGetNotificationInventoryReorder, IGetNotificationAutoCCDeclineCountList, IGetNotificationAutoCCDeclineDetail, IGetNotificationTasks, IGetNotificationAuctionEligibleSubCategory, IAuctionEligibleUnitDetailsModel, IGetNotificationApprovalCount, IApprovalsDetailsModel, IFacilityApprovalCount, IDeclinedACHPaymentNotification, IPendingBankResponseForAchNotification
} from '../../Shared/models/notification-model';
import { NotificationService } from '../../services/operations/notification.service';
import { CommonMethodService } from '../../Shared/common-method.service';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../services/operations/dashboard.service';
import { DatePipe } from '@angular/common';
import { NavigationExtras, Router } from '@angular/router';
import { DataService } from '../../facilityOperations/facOps-dashboard/data.service';
import { LoggerService } from '../../services/logger.service';
import { PaymentService } from '../../services/payment.service';
import { ILoggedInUser } from '../../Shared/models/ProspectModel';
import { UserSessionService } from '../../services/usersession.service';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GeneralService } from '../../services/general.service';
import { ReportsService } from '../../services/operations/reports.service';
import { IReportResponse } from '../../Shared/models/ReportsModel';
import { IStoreNameChange } from '../../Shared/interface2';
import { EAuctionEligibleUnitsApprovalStatus, EApprovalsDMRM, ELOV_ReservationUnitStatus, EPaymentModes, EUserFunctions, ENotificationOptions, ECountries, EAuctionSubCategoryType } from 'src/app/Shared/enum';
import { StoreinfoUnitService } from 'src/app/services/storeinfo-Units.service';
import { FacilityLocksComponent } from 'src/app/Shared/facility-locks/facility-locks.component';
import { INotificationSettings } from 'src/app/Shared/interface';
import { AppService } from 'src/app/services/app.service';
import { FacilityService } from 'src/app/services/facility.service';
import { EACHPaymentGateway } from 'src/app/Shared/enum';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
    selector: 'app-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    standalone: false
})
export class NotificationBarComponent implements OnInit, OnDestroy {
  NotificationRemovedFromAuctionList = false;
  NotificationScheduledForAuctionList =false;
  NotificationRemovedfromPendingRemotePaymentsList = false;
  getNotificationRemovedFromAuctionData: any;
  getNotificationScheduledForAuctionData: any;
  getNotificationRemovedFromPendingRemotePaymentscount: any;
  NotificationExpiredProofOfPPList = false;
  getNotificationExpiredProofOfPPsData: any;
  ENotificationOptions = ENotificationOptions;
  toastAlertMap = new Map<number, any>();
  notificationSettingsOption = [];
  notificationSettingId?: number;
  notificationAlertTimer?: number;
  @Input() isAdmin: boolean;
  @Input() lastAccessedFacility: number;
  @Input() toasterConfig: Object;
  @Input() AdminOrOps: string;
  @Input() storeNameChange: Subject<IStoreNameChange>;
  @Input() facilityDayendSetting: any;
  @Input() facilityLateAndLienSetting: any;
  @Output() showNotification = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();
  @ViewChild('printReceiptPopup') printFile!: ModalDirective;
  @ViewChild('removeNotificatonsModal', { static: true }) removepopup: TemplateRef<any>;
  @ViewChild(FacilityLocksComponent, { static: false }) FacilityLocksComponent: FacilityLocksComponent;
  datepipe: DatePipe = new DatePipe('en');
  public pageSize = 20;
  public pageNumber = 0;
  public totalRecords: number;
  public throttle = 150;
  public scrollDistance = 1;
  public inquiryDetails;
  public reservationDetails;
  isNotesTab = false;
  Notifi;
  private noticesInterval = environment.notificationIntervalInMinute;
  private baseURL = this.appService.config.apiBaseUrl;
  EAuctionEligibleUnitsApprovalStatus = EAuctionEligibleUnitsApprovalStatus;
  EApprovalsDMRM = EApprovalsDMRM;
  EAuctionSubCategoryType = EAuctionSubCategoryType;
  getNotificationCountObj;
  getNotificationFollowupsObj;
  getNotificationTasksObj
  getNotificationSchMoveInsObj;
  getNotificationSchMoveOutsObj;
  getNotificationUnitsLockedsObj;
  getNotificationUnitsUnLockedsObj;
  getNotificationAutoCreditCardDeclineObj;
  getNotificationAuctionEligibleSubCategoryObj;
  getNotificationApprovalsSubCategoryObj;
  getNotificationAuctionEligibleUnitsObj;
  getNotificationApprovalsObj;
  getNotificationAutoCCDeclineDetailsObj;
  getNotificationInventoryReorderObj;
  getNotificationOnRentalsObj;
  getNotificationOnPaymentsObj;
  getNotificationOnReservationsObj;
  getNotificationOnInquiriesObj;
  getNotificationCallCenterAlertsObj;
  getNotificationLettersAndNoticesObj;
  getNotificationDayEndReportsObj;
  getNotificationFileExportObj;
  getNotificationDeclinedACHPaymentsObj;
  getNotificationPendingBankResponseForAchObj;
  NotificationList = true;
  NotificationFollowDetail = false;
  NotificationTaskDetail = false;
  NotificationMoveInDetail = false;
  NotificationMoveOutDetail = false;
  NotificationPaymentDetail = false;
  NotificationUnitLockDetail = false;
  NotificationUnitUnLockDetail = false;
  NotificationAuctionEligibleSubCategory = false;
  NotificationApprovalsSubCategory = false;
  NotificationAuctionEligibleUnits = false;
  NotificationApprovals = false;
  NotificationAutoCreditCardDeclineDetail = false;
  NotificationAutoCCDeclineDetail = false;
  NotificationInventoryReorderDetail = false;
  NotificationRentalsDetail = false;
  NotificationReservationsDetail = false;
  NotificationInquiriesDetail = false;
  NotificationMailhouseErrorDateList = false;
  NotificationMailhouseDateDetail = false;
  NotificationCallCenterDetail = false;
  NotificationLettersInvoicesDetail = false;
  NotificationReportsDetail = false;
  NotificationFileExportsDetail = false;
  NotificationRentRaiseAltDetail = false;
  notificationDeclinedACHPayments = false;
  notificationPendingBankResponseForAch = false;
  letterGroupBYNameWise: any = [];
  letterGroupByNameList: any = [];
  NotificationLettersInvoicesDetailByName = false;
  letterGroupByNameListGrouped: any = [];
  NotificationLettersInvoicesDetailByNameDisplay = false;
  IsRemoveAllGroupByName = false;
  showFileExportPopup: any = false;
  FileExpRemove: any;
  FileDownloadInPopUp: any;
  dayLettersAndNoticeslist = [];
  getNotificationLettersAndNoticesObjByDate: any;
  NotificationLettersInvoicesDetailByDate = false;
  currentLetterAndNotices: any;
  getNotificationDayEndReportsObjByDate: any;
  NotificationReportsDetailByDate = false;
  NotificationScheduleReportsByDate = false;
  currentDayEndReports: any;
  LettersAndNoticeheader: any = '';
  loader_noti: Promise<boolean>;
  modalRefRemoveNotice: BsModalRef;
  modalRefRemoveAllNotice: BsModalRef;
  modalRefApprovalDifferentFacility: BsModalRef;
  RemoveNoticeobj;
  isCallCenterGroup = false;
  createRightforTask = false;
  notificationRentRaiseAlert: any;
  notificationMailhouseErrors: any;
  mailhouseErrorDetails: any;
  selectedDate;
  loggedinUserStoreGroups = [];
  getNotificationScheduleReportsData: any;
  NotificationScheduleReportsDetail = false;
  getNotificationScheduledReportsObj;
  currentScheduledReportList: any;
  isLicenseAndDavinciExist: boolean=false;
  lockDetailsList = [];
  Currentunitno: string;
  isNotification: boolean = false;
  showFacilitywithCount = false;
  showReversalFacilityCount = false;
  showRefundFacilityCount = false;
  AllowanceReversalFacilityCount = false;
  FacilityCountHeader;
  auctionapprovalforfac = false
  approvalConfirmRecordDetails = null;
  GetFacilityApprovalCountsObj = null;
  getFacilityAuctionEligibleUnitsCount = null;
  isSMAllStores = false;
  isDMAnyStore = false;
  isRMstore=false;
  UnSavedValue = 'Save failed';
  declinedACHPaymentsTitle = 'Declined ACH Payments';
  pendingBankResponseTitle = 'Pending Bank Response for ACH'
  notificationSub: any;
  NotificationAlert: any;
  finalAlertsList: any;
  notificationToaster: any;
  competitorSyncCompleteSub: any;
  facilitylist: any;
  isStripe = false;
  pendingACHStatusMap: { [key: number]: string } = {
    761: 'Payment Authenticated by User - Pending Bank Approval',
    818: 'Microdeposit Credit Initiated',
    819: 'Microdeposit Credited'
  };
  isDeclinedAchAutoReversalEnabled(): boolean {
    return !!this.facilityLateAndLienSetting?.AutoReverseDeclinedAchpayments;
  }
  notificationSettingsId: number;
  hasOptions: number;
  hasSettingsAssigned: boolean;
  modalConfig = {
  backdrop: 'static',
  keyboard: false
};

  constructor(private router: Router,
    public unitService: StoreinfoUnitService,
    private logger: LoggerService,
    private data: DataService,
    private paymentService: PaymentService,
    private notificationService: NotificationService,
    private commonMethodService: CommonMethodService,
    private toastr: ToastrService,
    private userSessionService: UserSessionService,
    private dashboardService: DashboardService,
    private modalService: BsModalService,
    public generalService: GeneralService,
    private appService: AppService,
    private reportService: ReportsService,
    private facilityService: FacilityService) {

    this.userSessionService.userDetailsChange.subscribe((userData: ILoggedInUser) => {
      if (this.AdminOrOps === 'Admin') {
        if (this.Notifi) {
          this.Notifi.unsubscribe();
        }
      }

      const loggedinUserId = this.userSessionService.userSessionData.UserId;
      this.loggedinUserStoreGroups = this.userSessionService.userSessionData.StoreGroupUsers.filter(sg => (
        sg.Approver == loggedinUserId || (sg.AlternateApprover1 == loggedinUserId && sg.AlternateAlert1) ||
        (sg.AlternateApprover2 == loggedinUserId && sg.AlternateAlert2)));
      this.isSMAllStores = this.loggedinUserStoreGroups.length == 0 ? true : false;
      this.isDMAnyStore = this.loggedinUserStoreGroups.findIndex(sg => sg.TypeId == this.EApprovalsDMRM.District) == -1 ? false : true;
      this.isRMstore=this.loggedinUserStoreGroups.findIndex(sg => sg.TypeId == this.EApprovalsDMRM.Region) == -1 ? false : true;
      if (this.lastAccessedFacility != 0 && this.isAdmin === false) {
        setTimeout(() => {
          this.getNotificationSettingsByUser();
        }, 3000);
      }
    });
  }

  ngOnInit() {
    if (this.userSessionService) {
      this.isCallCenterGroup = this.userSessionService.isCallcenterAgent === true ? true : false;
      const loggedinUserId = this.userSessionService.userSessionData.UserId;
      this.loggedinUserStoreGroups = this.userSessionService.userSessionData.StoreGroupUsers.filter(sg => (
        sg.Approver == loggedinUserId || sg.AlternateApprover1 == loggedinUserId || sg.AlternateApprover2 == loggedinUserId));
      this.isSMAllStores = this.loggedinUserStoreGroups.length == 0 ? true : false;
      this.isDMAnyStore = this.loggedinUserStoreGroups.findIndex(sg => sg.TypeId == this.EApprovalsDMRM.District) == -1 ? false : true;
      this.isRMstore = this.loggedinUserStoreGroups.findIndex(sg => sg.TypeId == this.EApprovalsDMRM.Region) == -1 ? false : true;
    }
    this.getNotificationSettingsByUser();
    this.storeNameChange.subscribe(val => {
      const lastAccessedFacility = val.Id;
      if (!lastAccessedFacility) {
        return;
      } else {
        this.lastAccessedFacility = val.Id;
        if (this.Notifi) {
          this.Notifi.unsubscribe();
          this.Notifi = undefined;
        }
      }
      this.callNotificationHub(lastAccessedFacility)
    });

    if (this.generalService.UserPermissions != undefined) {
      this.createRightforTask = this.generalService.getUserPermissionsForModule(EUserFunctions.Tasks).CreateRight;
    } else {
      this.generalService.userGroupPermissions.subscribe(response => {
        let usergrouppermissionList = response;
        if (usergrouppermissionList && usergrouppermissionList.Functions) {
          const taskPermissions = usergrouppermissionList.Functions.find(fun => fun.FunctionId == EUserFunctions.Tasks);
          if (taskPermissions && taskPermissions.UserGroupRights) {
            this.createRightforTask = taskPermissions.UserGroupRights.CreateRight;
          }
        }
      });
    }

    this.data.callGetNotficationCountEmitter.next(false);
    this.data.callGetNotficationCountEmitter.pipe(debounceTime(800),distinctUntilChanged()).subscribe((event) => {
      if (event) {
        this.data.callGetNotficationCountEmitter.next(false);
      }
    });
    this.isLicenseAndDavinciExist=false;
    this.IsLicenseAndDavinciExist();
    if (this.facilityService && this.generalService?.IsAdmin === false) {
      this.facilityService
        .getFacilityInfoACHForOp(this.lastAccessedFacility)
        .subscribe(response => {
          this.isStripe = response?.PaymentGateway == EACHPaymentGateway.Stripe;
        });
    }
  }

  ngOnDestroy() {
    if (this.Notifi) {
      this.Notifi.unsubscribe();
    }
    this.notificationSub?.unsubscribe();
    this.notificationToaster?.unsubscribe();
    this.competitorSyncCompleteSub?.unsubscribe();
  }


  setACHNotificationtitle () {
    if (this.userSessionService && this.userSessionService.allStoresListFromGetStores) {
      const accessedStoreModel = this.userSessionService.allStoresListFromGetStores.find(st => st.Id == this.lastAccessedFacility);
      if (accessedStoreModel) {
        this.declinedACHPaymentsTitle =  accessedStoreModel.CountryId == ECountries.Canada ? 'Declined EFT Payments' : 'Declined ACH Payments';
        this.pendingBankResponseTitle = accessedStoreModel.CountryId == ECountries.Canada ? 'Pending Bank Response for EFT' : 'Pending Bank Response for ACH';
      }
    }
  }
  HideNotificationFollowDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationFollowDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationTaskDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationTaskDetail = false;
    this.generalService.NotificationAlert=true; 
  }

  HideNotificationMoveInDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationMoveInDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationMoveOutDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationMoveOutDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationPaymentDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationPaymentDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationUnitLockDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationUnitLockDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationUnitUnLockDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationUnitUnLockDetail = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationApprovalSubCategory() {
    this.NotificationList = true;
    this.NotificationApprovalsSubCategory = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationApproval() {
    this.NotificationApprovals = false;
    this.NotificationApprovalsSubCategory = false;
    this.showFacilitywithCount = true;
    this.getNotificationApprovalsObj = null;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationApprovalsCount() {
    this.showFacilitywithCount = false;
    this.NotificationApprovalsSubCategory = true;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationAuctionEligibleSubCategory() {
    this.pageNumber = 0;
    this.NotificationAuctionEligibleSubCategory = false;
    this.auctionapprovalforfac = true;
    this.NotificationList = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationAuctionEligibleUnits() {
    this.pageNumber = 0;
    this.NotificationAuctionEligibleUnits = false;
    this.getNotificationAuctionEligibleUnitsObj = null;
    this.NotificationAuctionEligibleSubCategory = true;
    this.auctionapprovalforfac = false;
    this.NotificationList = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationAuctionApprovalfac() {
    this.NotificationList = true;
    this.auctionapprovalforfac = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationAutoCreditCardDeclineDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationAutoCreditCardDeclineDetail = false;
    this.NotificationAutoCCDeclineDetail = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationAutoCCDeclineDetail() {
    this.pageNumber = 0;
    this.NotificationAutoCreditCardDeclineDetail = true;
    this.NotificationAutoCCDeclineDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationInventoryReorderDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationInventoryReorderDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationRentalsDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationRentalsDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationReservationsDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationReservationsDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationInquiriesDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationInquiriesDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationCallCenterDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationCallCenterDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationLettersInvoicesDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationLettersInvoicesDetail = false;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationLettersInvoicesDetailByDate() {
    this.pageNumber = 0;
    this.NotificationList = false;
    this.NotificationLettersInvoicesDetail = true;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = true;
    this.NotificationLettersInvoicesDetailByNameDisplay = false;
  }

  HideNotificationLettersInvoicesDetailLetters() {
    this.NotificationList = false;
    this.NotificationLettersInvoicesDetail = false;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = true;
    this.NotificationLettersInvoicesDetailByNameDisplay = false;
  }

  HideNotificationLettersInvoicesDetailByName() {
    this.pageNumber = 0;
    this.NotificationList = false;
    this.NotificationLettersInvoicesDetail = true;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = false;
    this.NotificationLettersInvoicesDetailByNameDisplay = false;
  }

  HideNotificationReportsDetail() {
    this.pageNumber = 0;
    this.NotificationList = false;
    this.NotificationReportsDetail = false;
    this.NotificationReportsDetailByDate = true;
  }

  HideNotificationReportsDetailByDate() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationReportsDetail = false;
    this.NotificationReportsDetailByDate = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationFileExportsDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationFileExportsDetail = false;
     this.generalService.NotificationAlert=true;
  }

  HideNotificationRentRaiseAlt() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationRentRaiseAltDetail = false;
    this.generalService.NotificationAlert=true;
  }

  HideNotificationMailhouseDetail() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationMailhouseErrorDateList = false;
  }

  HideNotificationMailhouseDetailByDate() {
    this.pageNumber = 0;
    this.NotificationList = false;
    this.NotificationMailhouseErrorDateList = true;
    this.NotificationMailhouseDateDetail = false;
  }

  IsLicenseAndDavinciExist() {
    this.unitService.IsLicenseAndDavinciExistForOp(this.lastAccessedFacility).subscribe((res: boolean) => {
      this.isLicenseAndDavinciExist = res;
    })
  }
  onScrollDown(value) {
    this.pageNumber = this.pageNumber + 20;
    switch (value) {
      case 'followup':
        this.getNotificationFollowups(this.lastAccessedFacility);
        break;
      case 'task':
        this.getNotificationTask(this.lastAccessedFacility);
      case 'schedulemovein':
        this.getNotificationSchMoveIns(this.lastAccessedFacility);
        break;
      case 'schedulemoveout':
        this.getNotificationScheduledMoveOut(this.lastAccessedFacility);
        break;
      case 'Unitlock':
        this.getNotificationUnitsLocked(this.lastAccessedFacility);
        break;
      case 'Unitunlock':
        this.getNotificationUnitsUnLocked(this.lastAccessedFacility);
        break;
      case 'Onlinerental':
        this.getNotificationOnRentals(this.lastAccessedFacility);
        break;
      case 'Onlinepayments':
        this.getNotificationOnlinePayment(this.lastAccessedFacility);
        break;
      case 'Onlinereservation':
        this.getNotificationOnlineReservation(this.lastAccessedFacility);
        break;
      case 'Onlineinquiry':
        this.getNotificationOnlineInquiries(this.lastAccessedFacility);
        break;
      case 'callcentrealert':
        this.getNotificationCallCenterAlerts(this.lastAccessedFacility);
        break;
      case 'LettersAndNotices':
        this.getNotificationDayEndTenantLettersAndNotices(this.currentLetterAndNotices);
        break;
      case 'Dayendreports':
        this.getNotificationDayEndReports(this.currentDayEndReports);
        break;
      case 'Fileexports':
        this.getNotificationFileExport(this.lastAccessedFacility);
        break;
      case 'InventoryReorder':
        this.getNotificationInventoryReorder(this.lastAccessedFacility);
        break;
      case 'MailhouseErrors':
        this.getNotificationMailhouseDateDetail(this.selectedDate);
        break;
      case 'ScheduledReports':
        this.getNotificationScheduledReports(this.lastAccessedFacility)
        break;
      case 'ExpiredProofOfPP':
        this.getNotificationExpiredProofOfPP(this.lastAccessedFacility)
        break;
      case 'RemovedFromAuction':
        this.getNotificationRemovedFromAuction(this.lastAccessedFacility)
        break;
      case 'PendingRemotePayments':
        this.getNotificationPendingRemotePayments(this.lastAccessedFacility)
        break;
      case 'ScheduledForAuction':
        this.getNotificationScheduledForAuction(this.lastAccessedFacility)
      default:
        this.pageNumber = 0;
        break;
    }
  }

  getNotificationCount(facId) {
    this.setACHNotificationtitle();
    this.getNotificationCountObj['Approvals'] = this.getNotificationCountObj?.DMApprovals + this.getNotificationCountObj?.RMApprovals;
    this.getNotificationCountObj.TotalCount = this.getTotalCount();
    this.generalService.MastergetNotificationCountObj = this.getNotificationCountObj;
    this.showFileExportPopup = this.getNotificationCountObj?.FileExports != null || this.getNotificationCountObj?.FileExports?.length == 1 ? true : false;
    this.showFileExportPopup = true;
    if (this.showFileExportPopup) {
      this.FileDownloadInPopUp = this.getNotificationCountObj.FileExports[this.getNotificationCountObj.FileExports.length - 1];
    }
  }

  getNotificationFollowups(facId,isToaster?) {
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationFollowDetail = true;
    this.notificationService.getNotificationFollowUps(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationFollowUps[]) => {
      const notificationfollwup = response;
      let count = 0;
      for (let i = 0; i < notificationfollwup.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationFollowupsObj = notificationfollwup;
      } else {
        this.generalService.getNotificationFollowupsObj = this.generalService.getNotificationFollowupsObj.concat(notificationfollwup);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationTask(facId,isToaster?) {
    this.NotificationList = false;
    this.NotificationTaskDetail = true;
    this.notificationService.getNotificationTasks(facId).subscribe((
      response: IGetNotificationTasks[]) => {
      const notificationTask = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.generalService.getNotificationTasksObj = notificationTask;
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationSchMoveIns(facId,isToaster?) {
    const pagecount = this.pageNumber;
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationMoveInDetail = true;
    this.notificationService.getNotificationScheduledMoveIns(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationScheduledMove[]) => {
      let count = 0;
      const getnotificationschedulemovein = response;
      for (let i = 0; i < getnotificationschedulemovein.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationSchMoveInsObj = getnotificationschedulemovein;
      } else {
        this.generalService.getNotificationSchMoveInsObj = this.generalService.getNotificationSchMoveInsObj.concat(getnotificationschedulemovein);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationScheduledMoveOut(facId, isToaster?) {
    this.loader_noti = Promise.resolve(true);
    const pagecount = this.pageNumber;
    let count = 0;
    this.NotificationList = false;
    this.NotificationMoveOutDetail = true;
    this.notificationService.getNotificationScheduledMoveOut(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationScheduledMove[]) => {
      const getnotificationschedulemoveout = response;
      for (let i = 0; i < getnotificationschedulemoveout.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationSchMoveOutsObj = getnotificationschedulemoveout;
      } else {
        this.generalService.getNotificationSchMoveOutsObj = this.generalService.getNotificationSchMoveOutsObj.concat(getnotificationschedulemoveout);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  GetApprovalCount(isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationApprovalsSubCategory = true;
    this.notificationService.GetApprovalCount().subscribe((response:
      IGetNotificationApprovalCount) => {
      this.generalService.getNotificationApprovalsSubCategoryObj = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }

  GetApprovalDetails(facId) {
    let count = 0;
    let type = null;
    if (this.showReversalFacilityCount) {
      count =  this.generalService.getNotificationApprovalsSubCategoryObj.ReversalCount;
      type = EApprovalsDMRM.Reversal;
    } else if (this.showRefundFacilityCount) {
      count =  this.generalService.getNotificationApprovalsSubCategoryObj.RefundCount;
      type = EApprovalsDMRM.Refund;
    } else if (this.AllowanceReversalFacilityCount) {
      count =  this.generalService.getNotificationApprovalsSubCategoryObj.AllowanceReversalCount;
      type = EApprovalsDMRM.AllowanceReversal;
    }
    if (count != 0) {
      this.loader_noti = Promise.resolve(true);
      this.NotificationList = false;
      this.NotificationApprovalsSubCategory = false;
      this.showFacilitywithCount = false;
      this.NotificationApprovals = true;
      this.getNotificationApprovalsObj = null;
      this.serviceGetApprovalDetails(facId, type);
    }
  }
  serviceGetApprovalDetails(facId, type) {
    this.notificationService.GetApprovalDetails(facId, type).subscribe((response:
      IApprovalsDetailsModel[]) => {
      this.getNotificationApprovalsObj = {
        CategoryType: type == this.EApprovalsDMRM.Reversal ? 'Reversal' : (type == this.EApprovalsDMRM.Refund ? 'Refund' : 'Allowance Reversal'),
        UnitsList: response,
        FacilityId: facId
      };
      this.getNotificationApprovalsObj.UnitsList.map((ele) => {
        if (ele.MerchandiseRefundDetails && ele.MerchandiseRefundDetails.length) {
          ele.MerchandiseRefundDetails.map((item) => {
            item.Quantity = Math.abs(item.Quantity);
            item.Price = Math.abs(item.Price);
          });
        }
      });
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }

  onRoutetoApprovalCount(type, count) {
    if (count > 0) {
      this.loader_noti = Promise.resolve(true);
      this.GetFacilityApprovalCountsObj = null;
      this.showReversalFacilityCount = (type == 'Reversal') ? true : false;
      this.showRefundFacilityCount = (type == 'Refund') ? true : false;
      this.AllowanceReversalFacilityCount = (type == 'AllowanceReversalFacilityCount') ? true : false;
      this.FacilityCountHeader = (this.showReversalFacilityCount == true) ? 'Approve Reversals for Facilities' : this.showRefundFacilityCount == true ? 'Approve Refunds for Facilities' : 'Approve Allowance Reversals for Facilities';
      this.showFacilitywithCount = true;
      this.generalService.NotificationAlert=true
      this.NotificationList = false;
      this.NotificationApprovalsSubCategory = false;
      this.NotificationApprovals = false;
      let approvalType = null;
      if (this.showReversalFacilityCount) {
        approvalType = EApprovalsDMRM.Reversal;
      } else if (this.showRefundFacilityCount) {
        approvalType = EApprovalsDMRM.Refund;
      } else if (this.AllowanceReversalFacilityCount) {
        approvalType = EApprovalsDMRM.AllowanceReversal;
      }

      this.notificationService.GetFacilityApprovalCounts(approvalType).subscribe((response:
        IFacilityApprovalCount[]) => {
        this.GetFacilityApprovalCountsObj = response;
        this.loader_noti = Promise.resolve(false);
      }, err => {
        this.loader_noti = Promise.resolve(false);
      });
    }
  }

  approvaApprovalAuction() {
    if (this.approvalConfirmRecordDetails.IsAuction) {
      this.updateAuctionEligibleUnits(this.approvalConfirmRecordDetails.auctionUnit, this.approvalConfirmRecordDetails.approveStatus);
    } else {
      this.updateApproval(this.approvalConfirmRecordDetails.unitDetails, this.approvalConfirmRecordDetails.status, this.approvalConfirmRecordDetails.type);
    }
  }

  verifyApprovalRecordFacility(unitDetails: IApprovalsDetailsModel, status: number, type: string, template: TemplateRef<any>) {
    this.approvalConfirmRecordDetails = null;
    if (status == this.EApprovalsDMRM.Approved && unitDetails.FacilityId != this.lastAccessedFacility) {
      if ((type == 'Allowance Reversal' || (type == 'Refund') || (type == 'Reversal' && (unitDetails.PaymentModeId == EPaymentModes.CreditCard || unitDetails.PaymentModeId == EPaymentModes.HostedPage || unitDetails.PaymentModeId == EPaymentModes.ACH || unitDetails.PaymentModeId == EPaymentModes.CardOnfile || unitDetails.PaymentModeId == EPaymentModes.ACHOnFile)))) {
        this.approvalConfirmRecordDetails = {
          IsAuction: false,
          unitDetails: unitDetails,
          status: status,
          type: type,
          confirmPopUp: 1,
          confirmPopUpMessage: 'The record you are trying to Approve is from a different location. Do you wish to proceed?',
        }
      } else if ((type == 'Reversal' && (unitDetails.PaymentModeId == EPaymentModes.Cash || unitDetails.PaymentModeId == EPaymentModes.Check || unitDetails.PaymentModeId == EPaymentModes.DirectDebitEFT || unitDetails.PaymentModeId == EPaymentModes.ACHManualAuthorization || unitDetails.PaymentModeId == EPaymentModes.ManualAuthorization))) {
        let paymentModeTxt = '';
        switch (unitDetails.PaymentModeId) {
          case (EPaymentModes.Cash): paymentModeTxt = 'Cash';
            break;
          case (EPaymentModes.Check): paymentModeTxt = 'Check';
            break;
          case EPaymentModes.DirectDebitEFT: paymentModeTxt = 'Direct Debit EFT';
            break;
          case EPaymentModes.ACHManualAuthorization: paymentModeTxt = 'ACH Manual Authorization';
            break;
          case EPaymentModes.ManualAuthorization: paymentModeTxt = 'Manual Authorization';
            break;
        };
        this.approvalConfirmRecordDetails = {
          IsAuction: false,
          unitDetails: unitDetails,
          status: status,
          type: type,
          confirmPopUp: 2,
          confirmPopUpMessage: 'You cannot approve ' + paymentModeTxt + ' Reversal for a different location. Please switch store for Completing the Approval'
        }
      }
      this.modalRefApprovalDifferentFacility = this.modalService.show(template, { class: 'modal-dialog modal-dialog-centered', backdrop: 'static', keyboard: false });
    } else {
      this.updateApproval(unitDetails, status, type);
    }
  }

  updateApproval(unitDetails: IApprovalsDetailsModel, status: number, type: string) {
    this.approvalConfirmRecordDetails = null;
    if (this.modalRefApprovalDifferentFacility) {
      this.modalRefApprovalDifferentFacility.hide();
    }
    if (status == this.EApprovalsDMRM.Approved) {
      this.routeToRefundReversalOrLedger(unitDetails, type, false);
    } else {
      this.loading.emit(true);
      const object = {
        Id: unitDetails.Id,
        LeaseNo: unitDetails.LeaseNo,
        FacilityId: unitDetails.FacilityId,
        Type: type == 'Reversal' ? this.EApprovalsDMRM.Reversal : (type == 'Refund' ? this.EApprovalsDMRM.Refund : this.EApprovalsDMRM.AllowanceReversal),
        DMApprovalStatus: this.commonMethodService.isDMRMStoreGroup(this.loggedinUserStoreGroups, unitDetails.FacilityId) == 'DM' ? this.EApprovalsDMRM.Denied : null,
        RMApprovalStatus: this.commonMethodService.isDMRMStoreGroup(this.loggedinUserStoreGroups, unitDetails.FacilityId) == 'RM' ? this.EApprovalsDMRM.Denied : null,
        Amount: unitDetails.Amount
      };
      this.notificationService.DMorRMApprovalForRefundandReversal(object).subscribe((response: IRemoveResponse) => {
        if (response.Success === true) {
          this.GetApprovalCount();
          this.onRoutetoApprovalCount(type, 1);
          this.serviceGetApprovalDetails(unitDetails.FacilityId, type);
        } else {
        }
        this.loading.emit(false);
      }, err => {
        this.loading.emit(false);
      });
    }
  }

  GetAuctionEligibleSubCategoryCount(facId) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationAuctionEligibleSubCategory = true;
    this.auctionapprovalforfac = false;
    this.getNotificationAuctionEligibleSubCategoryObj = null;
    this.notificationService.GetAuctionEligibleSubCategoryCount(facId).subscribe((response:
      IGetNotificationAuctionEligibleSubCategory) => {
      this.getNotificationAuctionEligibleSubCategoryObj = {
        SubCategory: response,
        FacilityId: facId
      };
      this.loader_noti = Promise.resolve(false);
    });
  }

  GetAuctionEligibleUnits(auctionType, facId) {
    this.NotificationList = false;
    this.NotificationAuctionEligibleSubCategory = false;
    this.NotificationAuctionEligibleUnits = true;
    this.auctionapprovalforfac = false;
    this.getNotificationAuctionEligibleUnitsObj = null;
    this.loader_noti = Promise.resolve(true);
    this.notificationService.GetAuctionEligibleUnits(facId, auctionType).subscribe((response:
      IAuctionEligibleUnitDetailsModel[]) => {
      this.getNotificationAuctionEligibleUnitsObj = {
        CategoryType: auctionType == this.EAuctionSubCategoryType.Military ? 'Military' : (auctionType == this.EAuctionSubCategoryType.Bankruptcy ? 'Bankruptcy' : (auctionType == this.EAuctionSubCategoryType.OppositionToLien ? 'Opposition To Lien' : 'All Other Units')),
        UnitsList: response
      };
      this.loader_noti = Promise.resolve(false);
    });
  }

  AuctionApprovalsForFacilities(isToaster?) {
    this.auctionapprovalforfac = true;
    this.NotificationAuctionEligibleSubCategory = false;
    this.NotificationAuctionEligibleUnits = false;
    this.NotificationList = false;
    this.generalService.getFacilityAuctionEligibleUnitsCount = null;
    this.loader_noti = Promise.resolve(true);
    this.notificationService.GetFacilityAuctionEligibleUnitsCount().subscribe((response: IFacilityApprovalCount[]) => {
      this.generalService.getFacilityAuctionEligibleUnitsCount = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }

  verifyApprovalAuctionEligibleUnits(auctionUnit: IAuctionEligibleUnitDetailsModel, approveStatus: number, template: TemplateRef<any>) {
    this.approvalConfirmRecordDetails = null;
    if (approveStatus == this.EAuctionEligibleUnitsApprovalStatus.Approved) {
      if (auctionUnit.FacilityId == this.lastAccessedFacility) {
        this.updateAuctionEligibleUnits(auctionUnit, approveStatus);
      } else {
        this.approvalConfirmRecordDetails = {
          IsAuction: true,
          auctionUnit: auctionUnit,
          approveStatus: approveStatus,
          confirmPopUp: 1,
          confirmPopUpMessage: 'The record you are trying to Approve is from a different location. Do you wish to proceed?'
        }
        this.modalRefApprovalDifferentFacility = this.modalService.show(template, { class: 'modal-dialog modal-dialog-centered', backdrop: 'static', keyboard: false });
      }
    } else {
      this.updateAuctionEligibleUnits(auctionUnit, approveStatus);
    }
  }

  updateAuctionEligibleUnits(auctionUnit: IAuctionEligibleUnitDetailsModel, approveStatus: number) {
    this.approvalConfirmRecordDetails = null;
    if (this.modalRefApprovalDifferentFacility) {
      this.modalRefApprovalDifferentFacility.hide();
    }
    this.loading.emit(true);
    this.notificationService.UpdateNotificationAuctionUnit
      (auctionUnit.LeaseNo, auctionUnit.FacilityId, approveStatus)
      .subscribe((response: IRemoveResponse) => {
        if (response.Success === true) {
          if (approveStatus == this.EAuctionEligibleUnitsApprovalStatus.Approved) {
            const statusMsg = this.facilityLateAndLienSetting ? (this.facilityLateAndLienSetting.LeaseLevelAuctionLetter ?
              'Auction Approved' : 'Processed Auction Notice Successfully')
              : 'Auction Approved';
            this.toastr.success(statusMsg, 'Success', this.toasterConfig);
          } else {
            this.toastr.success('Auction Denied', 'Success', this.toasterConfig);
          }
          let category = this.getNotificationAuctionEligibleUnitsObj.CategoryType == 'Military' ? this.EAuctionSubCategoryType.Military :
            (this.getNotificationAuctionEligibleUnitsObj.CategoryType == 'Bankruptcy' ? this.EAuctionSubCategoryType.Bankruptcy : (this.getNotificationAuctionEligibleUnitsObj.CategoryType == 'Opposition To Lien' ? this.EAuctionSubCategoryType.OppositionToLien : this.EAuctionSubCategoryType.AllOtherUnits));
          this.AuctionApprovalsForFacilities();
          this.GetAuctionEligibleSubCategoryCount(auctionUnit.FacilityId);
          this.GetAuctionEligibleUnits(category, auctionUnit.FacilityId);

        } else {
          if (approveStatus == 566) {
            this.toastr.error('Failed to Approve Auction', 'Failure', this.toasterConfig);
          } else {
            this.toastr.error('Failed to Deny Auction', 'Failure', this.toasterConfig);
          }
        }
        this.loading.emit(false);
      }, err => {
        if (approveStatus == 566) {
          this.toastr.error('Failed to Approve Auction', 'Failure', this.toasterConfig);
        } else {
          this.toastr.error('Failed to Deny Auction', 'Failure', this.toasterConfig);
        }
        this.loading.emit(false);
      });
  }

  getNotificationUnitsLocked(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    const pagecount = this.pageNumber;
    let count = 0;
    this.notificationService.getNotificationUnitsLocked(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      if(response.length>0){
        this.NotificationList = false;
        this.NotificationUnitLockDetail = true;
        const getnotificationlock = response;
        for (let i = 0; i < getnotificationlock.length; i++) {
          count = count + 1;
        }
        if (isToaster) {
          this.loader_noti = Promise.resolve(false);
          this.showNotifications()
        }
        this.totalRecords = count;
        if (this.pageNumber === 0) {
          this.generalService.getNotificationUnitsLockedsObj = getnotificationlock;
        } else {
         this.generalService.getNotificationUnitsLockedsObj =  this.generalService.getNotificationUnitsLockedsObj.concat(getnotificationlock);
        }
        this.loader_noti = Promise.resolve(false);
      }
    });
  }

  getNotificationUnitsUnLocked(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    const pagecount = this.pageNumber;
    let count = 0;
    this.generalService.NotificationAlert = true;

    this.notificationService.getNotificationUnitsUnLocked(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      response.map((ele) => {
        if (ele.TransactionDate) {
          ele['FormattedTDate'] = this.commonMethodService.getFormattedDate(ele.TransactionDate);
        }
      })
      if(response.length >0) {
        this.NotificationList = false;
        this.NotificationUnitUnLockDetail = true;
        const getnotificationunlock = response;
        for (let i = 0; i < getnotificationunlock.length; i++) {
          count = count + 1;
        }
        if (isToaster) {
          this.loader_noti = Promise.resolve(false);
          this.showNotifications()
        }
        this.totalRecords = count;
        if (this.pageNumber === 0) {
          this.generalService.getNotificationUnitsUnLockedsObj = getnotificationunlock;
        } else {
         this.generalService.getNotificationUnitsUnLockedsObj =  this.generalService.getNotificationUnitsUnLockedsObj.concat(getnotificationunlock);
        }
        this.loader_noti = Promise.resolve(false);
      }
    });
  }

  getNotificationAutoCreditCardDecline(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationAutoCreditCardDeclineDetail = true;
    this.notificationService.getNotificationAutoCCDeclineCountList(facId).subscribe((response:
      IGetNotificationAutoCCDeclineCountList[]) => {
      this.generalService.getNotificationAutoCreditCardDeclineObj = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationAutoCCDeclineCountDetail(autoCCDecline: IGetNotificationAutoCCDeclineCountList) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationAutoCCDeclineDetail = true;
    this.NotificationAutoCreditCardDeclineDetail = false;
    this.notificationService.getNotificationAutoCCDeclineCountDetail(0, this.lastAccessedFacility, autoCCDecline.TransDate).
      subscribe((response: IGetNotificationAutoCCDeclineDetail[]) => {
        this.getNotificationAutoCCDeclineDetailsObj = response;
        this.loader_noti = Promise.resolve(false);
      });
  }

  getNotificationInventoryReorder(facId, isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationInventoryReorderDetail = true;
    this.notificationService.getNotificationInventoryReorder(facId).subscribe((response: IGetNotificationInventoryReorder[]) => {
      this.generalService.getNotificationInventoryReorderObj = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationOnRentals(facId ,isToaster?) {
    let count = 0;
    this.loader_noti = Promise.resolve(true);
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationRentalsDetail = true;

    this.notificationService.getNotificationOnRentals(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      const getnotificationonlinerental = response;
      for (let i = 0; i < getnotificationonlinerental.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationOnRentalsObj = getnotificationonlinerental;
      } else {
        this.generalService.getNotificationOnRentalsObj = this.generalService.getNotificationOnRentalsObj.concat(getnotificationonlinerental);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationOnlinePayment(facId, isToaster?) {
    this.loader_noti = Promise.resolve(true);
    let count = 0;
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationPaymentDetail = true;

    this.notificationService.getNotificationOnlinePayments(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      const getnotificationonpayment = response;
      for (let i = 0; i < getnotificationonpayment.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationOnPaymentsObj = getnotificationonpayment;
      } else {
        this.generalService.getNotificationOnPaymentsObj = this.generalService.getNotificationOnPaymentsObj.concat(getnotificationonpayment);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationOnlineReservation(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    let count = 0;
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationReservationsDetail = true;

    this.notificationService.getNotificationOnlineReservation(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      const getnotificationonreservation = response;
      for (let i = 0; i < getnotificationonreservation.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationOnReservationsObj = getnotificationonreservation;
      } else {
        this.generalService.getNotificationOnReservationsObj = this.generalService.getNotificationOnReservationsObj.concat(getnotificationonreservation);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationOnlineInquiries(facId,isToaster?) {
    let count = 0;
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationInquiriesDetail = true;

    this.loader_noti = Promise.resolve(true);
    this.notificationService.getNotificationOnlineInquiries(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      const getnotificationoninquiry = response;
      for (let i = 0; i < getnotificationoninquiry.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationOnInquiriesObj = getnotificationoninquiry;
      } else {
        this.generalService.getNotificationOnInquiriesObj = this.generalService.getNotificationOnInquiriesObj.concat(getnotificationoninquiry);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationDayEndTenantLettersAndNoticesByDate(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.notificationService.getNotificationDayEndTenantLettersAndNoticesByDate(facId).subscribe((response: any) => {
      this.NotificationLettersInvoicesDetail = true;
      this.NotificationLettersInvoicesDetailByName = false;
      this.NotificationLettersInvoicesDetailByNameDisplay = false;
      this.NotificationLettersInvoicesDetailByDate = false;
      this.NotificationList = false;
      this.generalService.getNotificationLettersAndNoticesObjByDate = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationDayEndReportsByDate(facId,isToaster?) {
    this.NotificationList = false;
    this.NotificationReportsDetailByDate = true;
    this.NotificationReportsDetail = false;
    this.loader_noti = Promise.resolve(true);
    this.notificationService.getNotificationDayEndReportsByDate(facId).subscribe((response: any) => {
      this.generalService.getNotificationDayEndReportsObjByDate = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      if (!this.generalService.getNotificationDayEndReportsObjByDate || this.generalService.getNotificationDayEndReportsObjByDate.length == 0) {
        this.NotificationReportsDetailByDate = false;
        this.NotificationList = true;
        this.NotificationReportsDetail = false;
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationCallCenterAlerts(facId ,isToaster?) {
    let count = 0;
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationCallCenterDetail = true;
    this.loader_noti = Promise.resolve(true);

    this.notificationService.getNotificationCallCenterAlerts(facId, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      const getnotificationcallcentre = response;
      for (let i = 0; i < getnotificationcallcentre.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationCallCenterAlertsObj = getnotificationcallcentre;
      } else {
        this.generalService.getNotificationCallCenterAlertsObj = this.generalService.getNotificationCallCenterAlertsObj.concat(getnotificationcallcentre);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  getNotificationRentRaiseAlt(facId, isToaster?) {
    this.NotificationRentRaiseAltDetail = true;
    this.NotificationList = false;
    this.notificationService.getNotificationRentRaiseAlt(facId).subscribe((response: any) => {
      this.generalService.notificationRentRaiseAlert = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      if (this.generalService.notificationRentRaiseAlert.length === 0) {
        this.NotificationRentRaiseAltDetail = false;
        this.NotificationList = true;
      }
    })
  }

  getNotificationDayEndTenantLettersAndNotices(noticeList) {
    this.currentLetterAndNotices = noticeList;
    const dayEndTypenoticeList = noticeList.Tag;
    this.LettersAndNoticeheader = dayEndTypenoticeList;
    const datenoticeList = this.onPipeDate(this.commonMethodService.getTimeZoneOffSetDate(noticeList.TDate));
    let count = 0;
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationLettersInvoicesDetail = false;
    this.generalService.NotificationAlert=true;
    this.NotificationLettersInvoicesDetailByDate = true;
    this.NotificationLettersInvoicesDetailByNameDisplay = false;
    this.NotificationLettersInvoicesDetailByName = false;

    if (this.LettersAndNoticeheader == 'Letters' && this.IsRemoveAllGroupByName == false) {
      this.getNotificationDayEndTenantLettersAndNoticesAll(noticeList);
    } else {
      this.loader_noti = Promise.resolve(true);
      this.notificationService.getNotificationDayEndTenantLettersAndNotices(this.lastAccessedFacility, dayEndTypenoticeList, datenoticeList, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
        const getnotificationletters = response;
        for (let i = 0; i < getnotificationletters.length; i++) {
          count = count + 1;
        }
        this.totalRecords = count;
        if (this.pageNumber === 0) {
          this.getNotificationLettersAndNoticesObj = getnotificationletters;
        } else {
          this.getNotificationLettersAndNoticesObj = this.getNotificationLettersAndNoticesObj.concat(getnotificationletters);
        }
        this.loader_noti = Promise.resolve(false);
      });
    }
  }

  getNotificationDayEndTenantLettersAndNoticesAll(noticeList) {
    this.currentLetterAndNotices = noticeList;
    const dayEndTypenoticeList = noticeList.Tag;
    this.LettersAndNoticeheader = dayEndTypenoticeList;
    const datenoticeList = this.onPipeDate(this.commonMethodService.getTimeZoneOffSetDate(noticeList.TDate));
    const pagecount = 0;
    this.loader_noti = Promise.resolve(true);

    this.notificationService.getNotificationDayEndTenantLettersAndNotices(this.lastAccessedFacility, dayEndTypenoticeList, datenoticeList, pagecount, noticeList.Cnt).subscribe((response: IGetNotificationUnitsLocked[]) => {
      if (response) {
        this.letterGroupByNameList = response;
        this.NotificationLettersInvoicesDetailByName = true;
        this.NotificationLettersInvoicesDetailByDate = false;
        this.NotificationLettersInvoicesDetailByNameDisplay = false;
        this.NotificationLettersInvoicesDetail = false;
        this.letterGroupBYNameWise = [];
        const obj = {};
        for (let i = 0, len = this.letterGroupByNameList.length; i < len; i++) {
          obj[this.letterGroupByNameList[i]['Notes']] = this.letterGroupByNameList[i];
        }
        this.letterGroupBYNameWise = new Array();
        for (const key in obj) {
          this.letterGroupBYNameWise.push(obj[key]);
        }
        this.letterGroupBYNameWise.map(el => {
          el['Length'] = this.letterGroupByNameList.filter(o => o.Notes == el.Notes).length;
        });
        this.loader_noti = Promise.resolve(false);
      }
    });
  }

  onClickGroupByName(selectName) {
    this.letterGroupByNameListGrouped = [];
    this.NotificationLettersInvoicesDetailByName = false;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByNameDisplay = true;
    this.letterGroupByNameListGrouped = this.letterGroupByNameList.filter(o => o.Notes == selectName.Notes);
  }

  generateAsPdfGroupedNameList(item) {
    this.NotificationList = true;
    this.NotificationLettersInvoicesDetail = false;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = false;
    this.showNotification.emit();
    const groupedbyName = this.letterGroupByNameList.filter(o => o.Notes == item.Notes);
    if (groupedbyName.length != 0) {
      this.preViewAll(groupedbyName, '');
    }
  }

  getNotificationDayEndReports(reportList) {
    this.currentDayEndReports = reportList;
    const datereportList = this.onPipeDate(this.commonMethodService.getTimeZoneOffSetDate(reportList.TDate));
    let count = 0;
    const pagecount = this.pageNumber;
    this.generalService.NotificationAlert = true;
    this.NotificationList = false;
    this.NotificationReportsDetailByDate = false;
    this.NotificationReportsDetail = true;
    this.loader_noti = Promise.resolve(true);
    this.notificationService.getNotificationDayEndReports(this.lastAccessedFacility, datereportList, pagecount, this.pageSize).subscribe((response: IGetNotificationUnitsLocked[]) => {
      const getdayendreports = response;
      for (let i = 0; i < getdayendreports.length; i++) {
        count = count + 1;
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.getNotificationDayEndReportsObj = getdayendreports;
      } else {
        this.getNotificationDayEndReportsObj = this.getNotificationDayEndReportsObj.concat(getdayendreports);
      }
      this.loader_noti = Promise.resolve(false);
    });
  }

  removeNotification() {
    this.loading.emit(true);
    if (this.RemoveNoticeobj.NotificationType == 'AutoCreditCardDecline') {
      this.notificationService.removeNotificationAutoCreditCardDecline
        (this.RemoveNoticeobj.Id, this.lastAccessedFacility, this.RemoveNoticeobj.tDate)
        .subscribe((response: IRemoveResponse) => {
          if (response.Success === true) {
            this.modalRefRemoveNotice?.hide();
            this.getNotificationAutoCreditCardDecline(this.lastAccessedFacility);
            if (this.NotificationAutoCCDeclineDetail) {
              let autoCCDecline: IGetNotificationAutoCCDeclineCountList = {
                TransDate: this.RemoveNoticeobj.tDate,
                Count: 0
              };
              this.getNotificationAutoCCDeclineCountDetail(autoCCDecline);
            }
            this.RemoveNoticeobj = {};
          }
          this.loading.emit(false);
        });
    } if (this.RemoveNoticeobj.NotificationType == 'Task') {
      this.notificationService.UpdateLookUpTask(this.RemoveNoticeobj.Id)
        .subscribe((response: IRemoveResponse) => {
          if (response.Success === true) {
            this.modalRefRemoveNotice.hide();
            this.getNotificationTask(this.lastAccessedFacility);
            this.RemoveNoticeobj = {};
            this.toastr.success('Task Completed Successfully', 'Success', this.toasterConfig);
          } else {
            this.toastr.error('Failed to complete Task', 'Failure', this.toasterConfig);
          }
          this.loading.emit(false);
        }, err => {
          this.toastr.error('Failed to complete Task', 'Failure', this.toasterConfig);
          this.loading.emit(false);
        });
    }
    if (this.RemoveNoticeobj.NotificationType === 'RentRaiseAlerts') {
      this.notificationService.UpdateRentRaiseBatch(this.RemoveNoticeobj.RentraiseBatchId)
        .subscribe((response: any) => {
          if (response.Success === true) {
            this.modalRefRemoveNotice.hide();
            this.getNotificationRentRaiseAlt(this.lastAccessedFacility);
            this.loading.emit(false);
          }
        })
    } else {
      this.notificationService.removeNotification(this.RemoveNoticeobj).subscribe((response: IRemoveResponse) => {
        if (response.Success === true) {
          this.generalService.NotificationAlert = true;
          if (this.RemoveNoticeobj.RemoveAll === false) {
            this.modalRefRemoveNotice?.hide();
            if (this.RemoveNoticeobj.NotificationType === 'UnitsToBeLocked') {
              this.pageNumber = 0;
              this.getNotificationUnitsLocked(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'UnitsToBeUnLocked') {
              this.pageNumber = 0;
              this.getNotificationUnitsUnLocked(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'OnlineRentals') {
              this.pageNumber = 0;
              this.getNotificationOnRentals(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'OnlinePayments') {
              this.pageNumber = 0;
              this.getNotificationOnlinePayment(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'OnlineReservations') {
              this.pageNumber = 0;
              this.getNotificationOnlineReservation(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'OnlineInquiries') {
              this.pageNumber = 0;
              this.getNotificationOnlineInquiries(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'CallCenterAlerts') {
              this.pageNumber = 0;
              this.getNotificationCallCenterAlerts(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'DayEnd') {
              this.pageNumber = 0;
              this.LettersAndNoticeheader = '';
              this.getNotificationDayEndTenantLettersAndNoticesByDate(this.lastAccessedFacility);
              this.getNotificationDayEndTenantLettersAndNotices(this.currentLetterAndNotices);
            } else if (this.RemoveNoticeobj.NotificationType === 'DayEndReports') {
              this.pageNumber = 0;
              this.getNotificationDayEndReports(this.currentDayEndReports);
            } else if (this.RemoveNoticeobj.NotificationType === 'MailhouseErrors') {
              this.pageNumber = 0;
              this.getNotificationMailhouseDateDetail(this.RemoveNoticeobj.tDate);
            } else if (this.RemoveNoticeobj.NotificationType === 'ScheduledReports') {
              this.pageNumber = 0;
              this.getNotificationScheduledReports(this.lastAccessedFacility)
            } else if (this.RemoveNoticeobj.NotificationType === 'RemovedFromAuction') {
              this.pageNumber = 0;
              this.getNotificationRemovedFromAuction(this.lastAccessedFacility)
            } else if (this.RemoveNoticeobj.NotificationType === 'PendingRemotePayments') {
              this.pageNumber = 0;
              this.getNotificationPendingRemotePayments(this.lastAccessedFacility)
            } else if (this.RemoveNoticeobj.NotificationType === 'DeclinedACHPayments') {
              this.pageNumber = 0;
              this.getNotificationDeclinedACHPayments(this.lastAccessedFacility);
            }else if (this.RemoveNoticeobj.NotificationType === 'ScheduledForAuction') {
              this.pageNumber = 0;
              this.getNotificationScheduledForAuction(this.lastAccessedFacility)
            }
          } else if (this.RemoveNoticeobj.RemoveAll === true) {
            if (this.RemoveNoticeobj.NotificationType === 'DayEnd') {
              this.getNotificationDayEndTenantLettersAndNoticesByDate(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'DayEndReports') {
              this.getNotificationDayEndReportsByDate(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType === 'MailHouseErrors') {
              this.getNotificationMailhouse(this.lastAccessedFacility);
            } else if (this.RemoveNoticeobj.NotificationType == 'UnitsToBeUnLocked'){
              this.NotificationUnitUnLockDetail = false;
              this.NotificationList=true;
              this.getNotificationUnitsUnLocked(this.lastAccessedFacility)
            }else if (this.RemoveNoticeobj.NotificationType == 'UnitsToBeLocked'){
              this.NotificationUnitLockDetail = false;
              this.NotificationList=true;
              this.getNotificationUnitsLocked(this.lastAccessedFacility)
            }
            this.modalRefRemoveNotice?.hide();
            this.modalRefRemoveAllNotice?.hide();
            this.loading.emit(false);
          }
          this.RemoveNoticeobj = {};
        } else {
          this.modalRefRemoveNotice.hide();
          this.toastr.error('Failed to remove the notification', 'Failure', this.toasterConfig);
        }
        this.loading.emit(false);
      });
    }
  }

  onPrintNotice(facId, type, noticeType) {
    if (type === 'All') {
      this.RemoveNoticeobj = {
        FacilityId: facId,
        NotificationType: noticeType,
        DayEndType: null,
        Id: null,
        RemoveAll: true
      };
    } else if (type === 'single') {
      this.RemoveNoticeobj = {
        FacilityId: facId,
        NotificationType: noticeType,
        DayEndType: null,
        Id: null,
        RemoveAll: false
      };
    }
    this.notificationService.removeNotification(this.RemoveNoticeobj).subscribe((response: IRemoveResponse) => {
      if (response.Success === true) {
        this.RemoveNoticeobj = {};
      }
    });
  }

  getNotificationFileExport(facId,isToaster?) {
    let count = 0;
    const pagecount = this.pageNumber;
    this.NotificationList = false;
    this.NotificationFileExportsDetail = true;
    this.loading.emit(true);
    this.notificationService.getNotificationFileExport(facId, pagecount, this.pageSize).subscribe((response: IFileExport[]) => {
      const getnotificationfileexports = response;
      for (let i = 0; i < getnotificationfileexports.length; i++) {
        count = count + 1;
      }
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.totalRecords = count;
      if (this.pageNumber === 0) {
        this.generalService.getNotificationFileExportObj = getnotificationfileexports;
      } else {
        this.generalService.getNotificationFileExportObj = this.generalService.getNotificationFileExportObj.concat(getnotificationfileexports);
      }
      this.loading.emit(false);
    });
  }

  redirectCustomerRentaltab(item, type) {
    this.loading.emit(true);
    if (item != undefined) {
      if (type === 'Payment') {
        const tabCus = 'rental';
        this.data.custimerInfoStorage = {
          facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
          leaseNo: item.LeaseNo,
          tenantId: item.TenantID,
          tab: tabCus
        };
      } else if (type === 'Units') {
        const tabCus = 'rental';
        this.data.custimerInfoStorage = {
          facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
          leaseNo: item.LeaseNo,
          tenantId: item.TenantID,
          tab: tabCus
        };
      } else if (type === 'Move') {
        const tabCus = 'rental';
        this.data.custimerInfoStorage = {
          facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
          leaseNo: item.LeaseNo,
          tenantId: item.TenantID,
          tab: tabCus
        };
      } else if (type === 'Rental') {
        const tabCus = 'rental';
        this.data.custimerInfoStorage = {
          facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
          leaseNo: item.LeaseNo,
          tenantId: item.TenantID ? item.TenantID : item.TenantId,
          tab: tabCus
        };
      } else if (type === 'ExpiredPP') {
        const tabCus = 'rental';
        this.data.custimerInfoStorage = {
          facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
          leaseNo: item.LeaseNo,
          tenantId: item.TenantId,
          tab: tabCus,
          buttonTab: 'ModifyRental',
        };
      }
      else if (type === 'SyncAuction') {
        const tabCus = 'rental';
        this.data.custimerInfoStorage = {
          facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
          leaseNo: item.LeaseNo,
          tenantId: item.TenantId,
          tab: tabCus,
          buttonTab: 'ModifyRental',
          syncAuction: true

        };
      }
      let tabsInvoked = {
        Rental: false,
        CustomerInfo: false,
        Dashboard: false,
        Cases: false
      }
      this.loading.emit(false);
      this.data.fromAzureSearch = tabsInvoked;
      this.data.invoiceSettingsApiInfo = null;
      this.userSessionService.notificationEmitter.emit(true);
      this.router.navigate(['/customer/rentals/'], { queryParams: { openSyncAuction: true } });
    } else {
      this.loading.emit(false);
    }
  }

  onAuctionClick(item)
  { 
    if(!item){ 
      return
    }
    if(!item.AuctioneerAuctionId){  
      this.redirectCustomerRentaltab(item,'SyncAuction')
    }
    else{
      this.redirectCustomerRentaltab(item,'Rental')
    }
  }

  onRemoveNoticeModel(ele, noticeType, showRemovePopup) {
    if (showRemovePopup) {
      this.modalRefRemoveNotice = this.modalService.show(this.removepopup, {
        class: 'modal-dialog  alert_box modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      });
    }
    if (noticeType === 'DayEndLetterInvoice') {
      this.RemoveNoticeobj = {
        FacilityId: ele.FacilityID,
        NotificationType: 'DayEnd',
        DayEndType: ele.DayEndType == undefined ? null : ele.DayEndType,
        Id: ele.Id,
        RemoveAll: false,
        tDate: null,
        IdList: []
      };
    } else if (noticeType === 'AutoCreditCardDecline') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: 'AutoCreditCardDecline',
        DayEndType: null,
        Id: ele.LeaseNo == undefined ? 0 : ele.LeaseNo,
        RemoveAll: false,
        tDate: ele.TransDate,
        IdList: []
      };
    } else if (noticeType === 'Task') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: 'Task',
        DayEndType: null,
        Id: ele.TaskId,
        RemoveAll: false,
        tDate: null,
        IdList: []
      };
    } else if (noticeType === 'RentRaiseAlerts') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: 'RentRaiseAlerts',
        transDate: ele.TransDate,
        RemoveAll: false,
        RentraiseBatchId: ele.RentraiseBatchId
      };
    } else if (noticeType === 'MailhouseErrors') {
      this.RemoveNoticeobj = {
        FacilityId: ele.FacilityId,
        NotificationType: 'MailHouseErrors',
        DayEndType: null,
        Id: ele.Id,
        RemoveAll: false,
        tDate: ele.tDate,
        IdList: [],
        MailHouseErrorLetter: ele.Tag
      };
    } else if (noticeType == 'RemovedFromAuction') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: "RemovedFromAuction",
        DayEndType: null,
        Id: ele.UnitactionId,
        RemoveAll: false,
        tDate: ele.Date ? this.datepipe.transform(new Date(ele.Date), 'yyyy-MM-dd') : '',
        IdList: []
      }
    }else if (noticeType == 'ScheduledForAuction') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: "ScheduledForAuction",
        DayEndType: null,
        Id: ele.UnitactionId,
        RemoveAll: false,
        tDate: ele.Date ? this.datepipe.transform(new Date(ele.Date), 'yyyy-MM-dd') : '',
        IdList: []
      }
    } else if (noticeType == 'DeclinedACHPayments') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: 'DeclinedACHPayments',
        DayEndType: null,
        Id: ele.TransactionId,
        RemoveAll: false,
        tDate: ele.TransactionDate ? this.datepipe.transform(new Date(ele.TransactionDate), 'yyyy-MM-dd') : '',
        IdList: []
      }
    }
    else if (noticeType == 'PendingRemotePayments') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: "PendingRemotePayments",
        DayEndType: null,
        Id: ele.Id,
        RemoveAll: false,
        tDate: ele.Date ? this.datepipe.transform(new Date(ele.Date), 'yyyy-MM-dd') : '',
        IdList: [],
        OrderId: ele.OrderId,
      }

    } else {
      this.RemoveNoticeobj = {
        FacilityId: ele.FacilityID,
        NotificationType: noticeType,
        DayEndType: ele.DayEndType == undefined ? null : ele.DayEndType,
        Id: ele.Id,
        RemoveAll: false,
        tDate: null,
        IdList: []
      };
    }
  }

  onRemAllNoticeModel(ele, noticeType, type, showRemovePopup) {
    if (showRemovePopup) {
      this.modalRefRemoveNotice = this.modalService.show(this.removepopup, {
        class: 'modal-dialog  alert_box modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      });
    }
    if (noticeType == 'MailhouseErrors') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: 'MailHouseErrors',
        DayEndType: null,
        Id: 0,
        RemoveAll: true,
        tDate: ele.TDate,
        IdList: []
      };
    } else if (noticeType == 'ScheduledReports') {
      this.RemoveNoticeobj = {
        FacilityId: this.lastAccessedFacility,
        NotificationType: "ScheduledReports",
        DayEndType: null,
        Id: ele.ScheduledId,
        RemoveAll: false,
        tDate: ele.Date ? ele.Date.substring(0, 10) : '',
        IdList: []
      };
    } else {
      if (type === 'GroupByName') {
        this.IsRemoveAllGroupByName = true;

        const IdListArr = [];
        const removeGroupByName = this.letterGroupByNameList.filter(o => o.Notes == ele.Notes);
        removeGroupByName.map(re => {
          IdListArr.push(re.Id);
        });
        this.RemoveNoticeobj = {
          FacilityId: this.lastAccessedFacility,
          NotificationType: 'DayEnd',
          DayEndType: 'Letters',
          Id: 0,
          RemoveAll: false,
          tDate: null,
          IdList: IdListArr
        };
      } else {
        this.IsRemoveAllGroupByName = false;

        if (noticeType === 'DayEndLetterInvoice') {
          this.RemoveNoticeobj = {
            FacilityId: this.lastAccessedFacility,
            NotificationType: 'DayEnd',
            DayEndType: ele.Tag == undefined ? null : ele.Tag,
            Id: 0,
            RemoveAll: true,
            tDate: this.onPipeTransDate(this.commonMethodService.getTimeZoneOffSetDate(ele.TDate)),
            IdList: []
          };
        } else {
          this.RemoveNoticeobj = {
            FacilityId: this.lastAccessedFacility,
            NotificationType: noticeType,
            DayEndType: null,
            Id: 0,
            RemoveAll: true,
            tDate: this.onPipeTransDate(this.commonMethodService.getTimeZoneOffSetDate(ele.TDate)),
            IdList: []
          };
        }
      }
    }
  }

  onRemoveFileExportModel(template: TemplateRef<any>, ele, noticeType) {
    this.modalRefRemoveNotice = this.modalService.show(template, {
      class: 'modal-dialog  alert_box modal-dialog-centered',
      backdrop: 'static',
      keyboard: false
    });
    this.FileExpRemove = ele.FileExportId;
  }

  removeFileExportNotification() {
    this.modalRefRemoveNotice.hide();
    this.notificationService.removeFileExportNotification(this.FileExpRemove,this.lastAccessedFacility).subscribe((response: IRemoveResponse) => {
      if (response) {
        this.pageNumber = 0;
        this.getNotificationFileExport(this.lastAccessedFacility);
      }
    });
  }

  onRemoveAllNoticeModel(template: TemplateRef<any>, facId, noticeType) {
    this.modalRefRemoveAllNotice = this.modalService.show(template, {
      class: 'modal-dialog  alert_box modal-dialog-centered',
      backdrop: 'static',
      keyboard: false
    });
    this.RemoveNoticeobj = {
      FacilityId: facId,
      NotificationType: noticeType,
      DayEndType: null,
      Id: null,
      RemoveAll: true,
      IdList: []
    };
  }

  generateAsPdfList(ele, noticeType, type) {
    this.NotificationList = true;
    this.NotificationReportsDetailByDate = false;
    this.NotificationReportsDetail = false;
    this.NotificationLettersInvoicesDetail = false;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = false;
    this.NotificationScheduleReportsByDate = false;
    this.NotificationScheduleReportsDetail = false;
    this.showNotification.emit();
    if (noticeType == 'DayEndLetterInvoice') {
      this.currentLetterAndNotices = ele;
      const dayEndTypenoticeList = ele.Tag;
      const datenoticeList = this.onPipeDate(this.commonMethodService.getTimeZoneOffSetDate(ele.TDate));
      const pagecount = this.pageNumber;
      this.loading.emit(true);
      this.notificationService.getNotificationDayEndTenantLettersAndNotices(this.lastAccessedFacility, dayEndTypenoticeList, datenoticeList, pagecount, ele.Cnt).subscribe((response: IGetNotificationUnitsLocked[]) => {
        this.dayLettersAndNoticeslist = response;
        if (this.dayLettersAndNoticeslist.length != 0) {
          this.onRemAllNoticeModel(ele, noticeType, type, false);
          this.preViewAll(this.dayLettersAndNoticeslist, noticeType);
        } else {
          this.loading.emit(false);
        }
      },
        (err: any) => {
          this.loading.emit(false);
          this.logger.log(err);
        });

    } else if (noticeType == 'DayEndReports') {
      this.loading.emit(true);
      this.currentDayEndReports = ele;
      const datereportList = this.onPipeDate(this.commonMethodService.getTimeZoneOffSetDate(ele.TDate));
      const pagecount = this.pageNumber;
      this.notificationService.getNotificationDayEndReports(this.lastAccessedFacility, datereportList, pagecount, ele.Cnt).subscribe((response: IGetNotificationUnitsLocked[]) => {
        this.dayLettersAndNoticeslist = response;
        if (this.dayLettersAndNoticeslist.length != 0) {
          this.onRemAllNoticeModel(ele, noticeType, type, false);
          this.preViewAll(this.dayLettersAndNoticeslist, noticeType);
        } else {
          this.loading.emit(false);
        }
      },
        (err: any) => {
          this.loading.emit(false);
          this.logger.log(err);
        });
    } else if (noticeType == 'ScheduledReports') {
      this.loading.emit(true);
      this.onRemAllNoticeModel(ele, noticeType, type, false);
      this.preViewAll(ele.Reports, noticeType);
    }
  }

  getNotificationMailhouseTemp(facId) {
    this.NotificationList = false;
    this.NotificationMailhouseErrorDateList = true;
  }

  getNotificationMailhouse(facId,isToaster?) {
    this.NotificationMailhouseErrorDateList = true;
    this.NotificationList = false;
    this.generalService.notificationMailhouseErrors = null;
    this.notificationService.GetNotificationMailhouseErrorByDate(facId).subscribe((response: any) => {
      response.map((ele) => {
        ele.TDate = this.commonMethodService.getFormattedDate(ele.TransactionDate);
      })
      this.generalService.notificationMailhouseErrors = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      if (!this.generalService.notificationMailhouseErrors || this.generalService.notificationMailhouseErrors.length == 0) {
        this.NotificationMailhouseErrorDateList = false;
        this.NotificationList = true;
      }
    }, (err) => {
      this.NotificationMailhouseErrorDateList = false;
      this.NotificationList = true;
    });
  }

  getNotificationMailhouseDateDetail(tDate) {
    const pagecount = this.pageNumber;
    this.generalService.NotificationAlert = true;
    this.NotificationMailhouseErrorDateList = false;
    this.NotificationMailhouseDateDetail = true;
    this.loading.emit(true);
    this.notificationService.GetNotificationMailhouseDetails(this.lastAccessedFacility, tDate, pagecount, this.pageSize).subscribe((response: any) => {
      const mailhouseErrors = response;
      this.selectedDate = tDate;
      if (this.pageNumber === 0) {
        this.mailhouseErrorDetails = mailhouseErrors;
      } else {
        this.mailhouseErrorDetails = this.mailhouseErrorDetails.concat(mailhouseErrors);
      }
      if (!this.mailhouseErrorDetails || this.mailhouseErrorDetails.length == 0) {
        this.NotificationMailhouseDateDetail = false;
        this.NotificationMailhouseErrorDateList = true;
      }
      this.loading.emit(false);
    }, (err) => {
      this.NotificationMailhouseDateDetail = false;
      this.NotificationMailhouseErrorDateList = true;
    });
  }

  private addDocumentIds(docIds, item, noticeType) {
    if (!item?.Id || (item.Location == null && item.ReportFile == null)) {
      return;
    }

    if (noticeType === 'ScheduledReports') {
      docIds.FacilityDayEndReportIds.push(item.Id);
      return;
    }

    const copies = (item.NoOfCopies != null && item.NoOfCopies != 0) ? item.NoOfCopies : 1;

    for (let i = 0; i < copies; i++) {
      if (noticeType === 'DayEndReports') {
        docIds.FacilityDayEndReportIds.push(item.Id);
        continue;
      }
      switch (item.DayEndType) {
        case 'Invoices':
          docIds.InvoiceIds.push(item.Id);
          break;
        case 'TenantLettersAndNotices':
          docIds.TenantLetterIds.push(item.Id);
          break;
        case 'TenantLettersAndNoticesAlternate':
          docIds.AlternateTenantLetterIds.push(item.Id);
          break;
        case 'Receipts':
          docIds.PaymentReceiptIds.push(item.Id);
          break;
      }
    }
  }

  generateAsPdf(Fpath, noticeType) {
    this.NotificationList = true;
    this.NotificationLettersInvoicesDetail = false;
    this.NotificationLettersInvoicesDetailByDate = false;
    this.NotificationLettersInvoicesDetailByName = false;
    this.NotificationLettersInvoicesDetailByNameDisplay = false;
    this.NotificationReportsDetail = false;
    this.NotificationReportsDetailByDate = false;
    this.NotificationScheduleReportsByDate = false;
    this.NotificationScheduleReportsDetail = false;
    this.showNotification.emit();
    this.onRemoveNoticeModel(Fpath, noticeType, false);
    const docIds = { FacilityDayEndReportIds: [], InvoiceIds: [], TenantLetterIds: [], AlternateTenantLetterIds: [], PaymentReceiptIds: [] };
    this.addDocumentIds(docIds, Fpath, noticeType);
    if (docIds.FacilityDayEndReportIds.length > 0 || docIds.InvoiceIds.length > 0 || docIds.TenantLetterIds.length > 0 || docIds.AlternateTenantLetterIds.length > 0 || docIds.PaymentReceiptIds.length > 0) {
      this.loading.emit(true);
      this.paymentService.generatePDF(docIds).subscribe(response => {
        if (response.Success) {
          const byteCharacters = atob(response.FileContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const fileUrl = URL.createObjectURL(blob);

          this.printFile.show();
          const iFrame = document.getElementsByTagName('iframe')[0];
          iFrame.src = fileUrl;
          document.getElementById('recieptContainer').appendChild(iFrame);

          this.notificationService.removeNotification(this.RemoveNoticeobj).subscribe((response: IRemoveResponse) => {
            if (response.Success === true) {
              this.RemoveNoticeobj = {};
            }
          });
        }
        else {
          this.toastr.error('Files not available to print', 'Failure', this.toasterConfig);
        }
        this.loading.emit(false);
      },
        (err: any) => {
          this.loading.emit(false);
          this.toastr.error('File path was Invalid', 'Failure', this.toasterConfig);
          this.logger.log(err);
        });
    } else {
      this.loading.emit(false);
      this.toastr.error('File is not available to print', 'Failure', this.toasterConfig);
    }
  }

  FollowUpsRoute(item) {
    this.data.followUpsData = {
      RouterFor: 'Notification',
      followUpobj: item
    };
    if (this.router.url != '/facilityAdmin/batch-followup') {
      this.router.navigate(['/facilityAdmin/batch-followup']);
    } else if (this.router.url == '/facilityAdmin/batch-followup') {
      this.loading.emit(true);
      this.router.navigate(['/facilityAdmin']);
      this.loading.emit(false);
    }
  }

  redirectCustomerCustomerInfo(details) {
    this.data.custimerInfoStorage = {
      facilityID: details.FacilityId,
      leaseNo: details.LeaseNo,
      tenantId: details.TenantID,
      tab: 'customerInfo',
    };
    let tabsInvoked = {
      Rental: false,
      CustomerInfo: false,
      Dashboard: false,
      Cases: false
    }
    this.loading.emit(false);
    this.data.fromAzureSearch = tabsInvoked;
    this.userSessionService.notificationEmitter.emit(true);
    this.data.invoiceSettingsApiInfo = null;
    this.router.navigate(['/customer/customer-info/']);
  }

  callCenterRedirect(item) {
    if (item.Location === 'Rental') {
      this.data.custimerInfoStorage = {
        facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
        leaseNo: item.LeaseNo,
        tenantId: item.TenantID,
        tab: 'dashboard',
      };
      let tabsInvoked = {
        Rental: false,
        CustomerInfo: false,
        Dashboard: false,
        Cases: false
      }
      this.loading.emit(false);
      this.data.fromAzureSearch = tabsInvoked;
      this.userSessionService.notificationEmitter.emit(true);
      this.data.invoiceSettingsApiInfo = null;
      this.router.navigate(['/customer/dashboard/']);
    } else if (item.Location === 'Reservation') {
      this.isNotesTab = true;
      this.reservationDetailsById(item, 'callcenter');
    } else if (item.Location === 'Inquiry') {
      this.isNotesTab = true;
      this.inquiryById(item, 'callcenter');
    }
  }

  reservationDetailsById(item, type) {
    this.loading.emit(true);
    let id = type == 'callcenter' ? item.ProspectsId : item.Id;
    this.dashboardService.getReservationDetailsById(id, this.userSessionService.isCallcenterAgent)
      .subscribe((response) => {

        this.reservationDetails = response;
        let resUnitInfo = response.UnitInfo;
        this.reservationDetails.DateRequired = this.commonMethodService.getAPIDateTimeToLocalDatePart(this.reservationDetails.DateRequired);
        let url = '/prospect/reservation/';
        if (this.isNotesTab) {
          this.data.ReservationDetails = {
            facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
            leaseNo: item.LeaseNo == null ? this.reservationDetails.LeaseNumber : item.LeaseNo,
            tenantId: item.TenantID,
            tab: 'prospect',
            resObj: this.reservationDetails,
            RouterFor: 'Notification'
          };
          this.isNotesTab = false;
        } else {
          this.data.ReservationDetails = {
            facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
            leaseNo: item.LeaseNo == null ? this.reservationDetails.LeaseNumber : item.LeaseNo,
            tenantId: item.TenantID,
            tab: 'prospect',
            resObj: this.reservationDetails,
          };
        }
        if (resUnitInfo && (this.reservationDetails.Status == ELOV_ReservationUnitStatus.ReservationRented || resUnitInfo.UnitStatusId == 195)) {
          this.data.notiOnlineReservationEmitter.emit(true);
          var tab = "UnitInfo"
          url = `/prospect/prsEd/${item.TenantID}/false/ed/${tab}`
        } else {
          url = '/prospect/reservation/';
        }
        if (this.reservationDetails != undefined) {
          this.loading.emit(false);
          this.data.onlineResNotificationRouteEmitter.next(true);
          this.router.navigate([url]);
        }
      });
  }

  downloadFile(item) {
    if (item != undefined) {
      const link = document.createElement('a');
      link.download = item.Name;
      link.href = item.FileName;
      link.click();
    }
    this.notificationService.removeFileExportNotification(item.FileExportId,this.lastAccessedFacility).subscribe((response: IRemoveResponse) => {
      if (response) {
        this.pageNumber = 0;
        this.getNotificationFileExport(this.lastAccessedFacility);
      }
    });
  }

  preViewAll(printlist, noticeType) {
    const docIds = { FacilityDayEndReportIds: [], InvoiceIds: [], TenantLetterIds: [], AlternateTenantLetterIds: [], PaymentReceiptIds: [] };
    let hasDownloadFiles = false;

    printlist.forEach(ele => {
      const doc = ele.Location || ele.ReportFile;
      const file = doc?.split('?')[0].toLowerCase();

      if (file?.endsWith('.csv') || file?.endsWith('.xlsx')) {
        hasDownloadFiles = true;

        const link = document.createElement('a');
        link.href = doc;
        link.download = decodeURIComponent(file.substring(file.lastIndexOf('/') + 1));

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.addDocumentIds(docIds, ele, noticeType);
      }
    });

    if (docIds.FacilityDayEndReportIds.length || docIds.InvoiceIds.length || docIds.TenantLetterIds.length || docIds.AlternateTenantLetterIds.length || docIds.PaymentReceiptIds.length) {
      this.loading.emit(true);
      this.paymentService.generatePDF(docIds).subscribe(response => {
        if (response.Success) {
          this.printFile.show();
          const byteCharacters = atob(response.FileContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const iFrame = document.getElementsByTagName('iframe')[0];
          iFrame.src = url;
          document.getElementById('recieptContainer').appendChild(iFrame);
          this.notificationService.removeNotification(this.RemoveNoticeobj).subscribe((response: IRemoveResponse) => {
            if (response.Success === true) {
              this.RemoveNoticeobj = {};
            }
          });
        } else {
          this.toastr.error('Files not available to print', 'Failure', this.toasterConfig);
        }
        this.loading.emit(false);
      },
        (err: any) => {
          this.loading.emit(false);
          this.toastr.error('Some of the file path was Invalid', 'Failure', this.toasterConfig);
          this.logger.log(err);
        });
    } else {
      if (hasDownloadFiles) {
        this.notificationService.removeNotification(this.RemoveNoticeobj)
          .subscribe((response: IRemoveResponse) => {
            if (response.Success === true) {
              this.RemoveNoticeobj = {};
            }
          });
      } else {
        this.toastr.error('Files not available to print', 'Failure', this.toasterConfig);
      }
      this.loading.emit(false);
    }
  }

  inquiryById(item, type) {
    this.loading.emit(true);
    let id = type == 'callcenter' ? item.ProspectsId : item.Id;
    this.dashboardService.getInquiryDetailsById(id, this.userSessionService.isCallcenterAgent)
      .subscribe((response) => {
        this.inquiryDetails = response;
        this.inquiryDetails.DateRequired = this.commonMethodService.getAPIDateTimeToLocalDatePart(this.inquiryDetails.DateRequired);

        const url = '/prospect/Inquiry/';
        if (this.isNotesTab) {
          this.data.InquiryDetails = {
            id: item.Id,
            facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
            leaseNo: item.LeaseNo,
            tenantId: item.TenantID,
            tab: 'prospect',
            obj: this.inquiryDetails
          };
          this.isNotesTab = false;
        } else {
          this.data.InquiryDetails = {
            id: item.Id,
            facilityID: item.FacilityId == undefined ? item.FacilityID : item.FacilityId,
            leaseNo: item.LeaseNo,
            tenantId: item.TenantID,
            tab: 'prospect',
            obj: this.inquiryDetails
          };
        }
        if (this.inquiryDetails != undefined) {
          this.loading.emit(false);
          this.data.onlineInqNotificationRouteEmitter.next(true);
          this.router.navigate([url]);
        }
      });
  }

  redirectMerchandiseInventory() {
    const createRightforMIorder = this.generalService.getUserPermissionsForModule(EUserFunctions['Merchandise Inventory : Order']).CreateRight;
    const createRightforMIReceive = this.generalService.getUserPermissionsForModule(EUserFunctions['Merchandise Inventory : Receive']).CreateRight;
    const createRightforMITransfer = this.generalService.getUserPermissionsForModule(EUserFunctions['Merchandise Inventory : Transfer']).CreateRight;
    const createRightforMIAdjustment = this.generalService.getUserPermissionsForModule(EUserFunctions['Merchandise Inventory : Audit/Adjustment - Add']).CreateRight;
    if (createRightforMIorder && createRightforMIReceive && createRightforMITransfer && createRightforMIAdjustment) {
      const url = '/facimer/mi';
      this.router.navigate([url]);
    }
  }

  onPipeDate(formDate) {
    if (formDate !== null && formDate !== '') {
      const tempDate = new Date(formDate);
      const date = new Date(tempDate);
      return this.datepipe.transform(date, 'yyyy-MM-dd');
    }
  }

  onPipeTransDate(formDate) {
    if (formDate !== null && formDate !== '') {
      const tempDate = new Date(formDate);
      const date = new Date(tempDate);
      return this.datepipe.transform(date, 'yyyy-MMM-dd');
    }
  }

  printNotificationAutoCreditCardDecline(declineModel: IGetNotificationAutoCCDeclineCountList) {
    this.loader_noti = Promise.resolve(true);
    this.generalService.getReportUrl().subscribe((response: any) => {
      const reportUrl = response;
      const pipe = new DatePipe('en-US');
      const obj = {
        ReportName: "DeclinedCreditCardList",
        ReportParameters: {},
        SortBy: 1,
        StorageFacilities: [this.lastAccessedFacility]
      };
      obj.ReportParameters["FromDate"] = declineModel.TransDate;
      obj.ReportParameters["ToDate"] = declineModel.TransDate;
      var openInNewTab = '_blank';
      this.reportService.generateReport(obj).subscribe((response: IReportResponse) => {
        if (response.Success) {
          window.open(reportUrl + `report?id=` + response.ReportRequestId,
            openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
          this.loader_noti = Promise.resolve(false);
        } else {
          this.loader_noti = Promise.resolve(false);
        }
      });
    });
  }

  gotoCustomerRentalTab(autoCCDeclineDetail: IGetNotificationAutoCCDeclineDetail) {
    const viewRightforCustomer = this.generalService.getUserPermissionsForModule(EUserFunctions.Dashboard).ViewRight;
    if (viewRightforCustomer) {
      this.data.custimerInfoStorage = {
        facilityID: this.lastAccessedFacility,
        leaseNo: autoCCDeclineDetail.LeaseNo,
        tenantId: autoCCDeclineDetail.Id,
        tab: 'rental'
      };
      this.data.invoiceSettingsApiInfo = null;
      this.router.navigate(['/customer/rentals/']);
    }
  }

  routToTaskCreate() {
    const url = 'facilityAdmin/batch-lookup/batch-lookup-newtask/' + 0;
    this.router.navigate([url]);
    this.loader_noti = Promise.resolve(true);
  }

  routToTaskDetail(item: IGetNotificationTasks) {
    const viewRightforTask = this.generalService.getUserPermissionsForModule(EUserFunctions.Tasks).ViewRight;
    if (viewRightforTask) {
      const url = 'facilityAdmin/batch-lookup/batch-lookup-newtask/' + item.TaskId;
      this.router.navigate([url]);
      this.loader_noti = Promise.resolve(true);
    }
  }

  selectTask(item: IGetNotificationTasks) {
    this.loader_noti = Promise.resolve(true);
    this.notificationService.getNotificationTasks(this.lastAccessedFacility).subscribe((response: IGetNotificationTasks[]) => {
      const notificationTask = response;
      this.getNotificationTasksObj = notificationTask;
      this.loader_noti = Promise.resolve(false);
    });
  }

  routeToRefundReversalOrLedger(details: IApprovalsDetailsModel, type: string, isLedger) {
    this.data.notificationToRefundReversal = {
      ReversalPaymentModeDetailsId: null,
      ApprovalId: null
    };
    if (isLedger || !details.MerchandiseSaleId) {
      const viewRightforCustomer = this.generalService.getUserPermissionsForModule(EUserFunctions.Dashboard).ViewRight;
      if (viewRightforCustomer) {
        this.data.custimerInfoStorage = {};
        if (isLedger) {
          this.data.custimerInfoStorage = {
            facilityID: details.FacilityId,
            leaseNo: details.LeaseNo,
            tenantId: details.TenantId,
            tab: 'rental',
            buttonTab: 'Ledger'
          };
        } else {
          this.data.custimerInfoStorage = {
            facilityID: details.FacilityId,
            leaseNo: details.LeaseNo,
            tenantId: details.TenantId,
            tab: 'rental',
            buttonTab: type
          };
          this.data.notificationToRefundReversal = {
            ReversalPaymentModeDetailsId: type == 'Reversal' ? details.PaymentModeDetailsId : null,
            AllowanceId: type == 'Allowance Reversal' ? details.AllowanceId : null,
            ApprovalId: details.Id,
            Amount: details.Amount,
            FacilityId: details.FacilityId,
            LeaseNo: details.LeaseNo
          };
        }
        this.data.notificationRouteEmitter.next(true);
        this.data.invoiceSettingsApiInfo = null;
        this.router.navigate(['/customer/rentals/']);
      }
    } else {
      this.data.notificationToMerchRefund = {
        FromNotification: true,
        FacilityId: details.FacilityId,
        LeaseNo: details.LeaseNo,
        TenantId: details.TenantId,
        MerchandiseSaleId: details.MerchandiseSaleId
      };
      if (this.router.url.includes('facimer/mrefund')) {
        this.showNotification.emit();
        this.userSessionService.notificationEmitter.emit(true);
      } else {
        this.router.navigate(['facimer/mrefund']);
      }
    }
  }

  declinedACHPaymentsRouteToLedger(details) {
    this.data.notificationToRefundReversal = {
    };
    const viewRightforCustomer = this.generalService.getUserPermissionsForModule(EUserFunctions.Dashboard).ViewRight;
    if (viewRightforCustomer) {
      this.data.custimerInfoStorage = {
        facilityID: details.FacilityId,
        leaseNo: details.LeaseNo,
        tenantId: details.TenantId,
        tab: 'rental',
        buttonTab: 'Reversal'
      };
      this.data.notificationToRefundReversal = {
        ReversalPaymentModeDetailsId: details.PaymentModeDetailsId,
        Amount: details.Amount,
        FacilityId: details.FacilityId,
        LeaseNo: details.LeaseNo,
        DeclinedACH_EFTTransaction: details.TransactionId
      };
      this.data.notificationRouteEmitter.next(true);
      this.router.navigate(['/customer/rentals/']);
    }
  }

  getNotificationScheduledReports(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.notificationService.GetScheduledReportNotification(facId).subscribe((response: any) => {
      this.generalService.getNotificationScheduleReportsData = response;
      this.NotificationList = false;
      this.NotificationScheduleReportsByDate = true;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }

  HideNotificationScheduleReportsByDate() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationScheduleReportsDetail = false;
    this.NotificationScheduleReportsByDate = false;
    this.generalService.NotificationAlert =true;

  }

  HideNotificationScheduleReportsDetail() {
    this.pageNumber = 0;
    this.NotificationList = false;
    this.NotificationScheduleReportsDetail = false;
    this.NotificationScheduleReportsByDate = true;
  }

  getNotificationScheduledReportsDetail(reportData) {
    this.currentScheduledReportList = reportData;
    this.generalService.NotificationAlert = true;
    this.NotificationList = false;
    this.NotificationScheduleReportsByDate = false;
    this.NotificationScheduleReportsDetail = true;
    this.loader_noti = Promise.resolve(true);
    this.getNotificationScheduledReportsObj = reportData.Reports;
    this.loader_noti = Promise.resolve(false);
  }

  displayNotificationList() {
    this.NotificationList = true;
    this.NotificationFollowDetail = false;
    this.NotificationTaskDetail = false;
    this.NotificationMoveInDetail = false;
    this.NotificationMoveOutDetail = false;
    this.NotificationPaymentDetail = false;
    this.NotificationUnitLockDetail = false;
    this.NotificationUnitUnLockDetail = false;
    this.NotificationAuctionEligibleSubCategory = false;
    this.NotificationApprovalsSubCategory = false;
    this.NotificationAuctionEligibleUnits = false;
    this.NotificationApprovals = false;
    this.showFacilitywithCount = false;
    this.NotificationAutoCreditCardDeclineDetail = false;
    this.NotificationAutoCCDeclineDetail = false;
    this.NotificationInventoryReorderDetail = false;
    this.NotificationRentalsDetail = false;
    this.NotificationReservationsDetail = false;
    this.NotificationInquiriesDetail = false;
    this.NotificationCallCenterDetail = false;
    this.NotificationLettersInvoicesDetail = false;
    this.NotificationReportsDetail = false;
    this.NotificationFileExportsDetail = false;
    this.NotificationRentRaiseAltDetail = false;
    this.NotificationMailhouseErrorDateList = false;
    this.NotificationMailhouseDateDetail = false;
    this.NotificationScheduleReportsDetail = false;
    this.NotificationApprovalsSubCategory = false;
    this.NotificationExpiredProofOfPPList = false;
    this.NotificationReportsDetailByDate=false;
    this.NotificationRemovedFromAuctionList = false;
    this.NotificationScheduledForAuctionList = false;
    this.notificationDeclinedACHPayments = false;
    this.NotificationRemovedfromPendingRemotePaymentsList = false
    this.showFacilitywithCount = false;
    this.auctionapprovalforfac = false;
    this.NotificationReportsDetailByDate=false;
    this.NotificationReportsDetailByDate = false;
    this.notificationPendingBankResponseForAch = false;
  }
  clearDataObjects() {
    this.generalService.getNotificationApprovalsSubCategoryObj = null;
    this.getNotificationApprovalsObj = null;
    this.generalService.getNotificationFollowupsObj = null;
    this.generalService.getNotificationTasksObj = null;
    this.generalService.getNotificationSchMoveInsObj = null;
    this.generalService.getNotificationSchMoveOutsObj = null;
    this.getNotificationAuctionEligibleSubCategoryObj = null;
    this.getNotificationAuctionEligibleUnitsObj = null;
    this.generalService.getNotificationUnitsLockedsObj = null;
    this.generalService.getNotificationUnitsUnLockedsObj = null;
    this.generalService.getNotificationAutoCreditCardDeclineObj = null;
    this.generalService.getNotificationInventoryReorderObj = null;
    this.generalService.getNotificationOnRentalsObj = null;
    this.generalService.getNotificationOnPaymentsObj = null;
    this.generalService.getNotificationOnReservationsObj = null;
    this.generalService.getNotificationOnInquiriesObj = null;
    this.generalService.notificationRentRaiseAlert = null;
    this.generalService.getNotificationCallCenterAlertsObj = null;
    this.generalService.getNotificationLettersAndNoticesObjByDate = null;
    this.getNotificationLettersAndNoticesObj = null;
    this.generalService.getNotificationRemovedFromPendingRemotePaymentscount=null;
    this.letterGroupBYNameWise = [];
    this.generalService.getNotificationDayEndReportsObjByDate = null;
    this.getNotificationDayEndReportsObj = null;
    this.generalService.getNotificationFileExportObj = null;
    this.generalService.notificationMailhouseErrors = null;
    this.mailhouseErrorDetails = null;
    this.getNotificationScheduledReportsObj = null;
    this.GetFacilityApprovalCountsObj = null;
    this.generalService.getNotificationScheduleReportsData=null;
    this.generalService.getNotificationRemovedFromAuctionData=null;
    this.generalService.getNotificationScheduledForAuctionData=null;
    this.generalService.getNotificationPendingBankResponseForAchObj = null;
    this.generalService.getNotificationDeclinedACHPaymentsObj = null;
    this.generalService.getFacilityAuctionEligibleUnitsCount = null; 
}

  OpenSyncModal(item) {
    this.RemoveNoticeobj = {
      FacilityId: item.FacilityID,
      NotificationType: 'UnitsToBeLocked',
      DayEndType: item.DayEndType == undefined ? null : item.DayEndType,
      Id: item.Id,
      RemoveAll: false,
      tDate: null,
      IdList: []
    };
    //this.NotificationUnitLockDetail = false;
    this.lockDetailsList = item.LockDetailsList;
    this.Currentunitno = item.UnitNo;
    this.FacilityLocksComponent.getLienDetails(this.Currentunitno);
    this.FacilityLocksComponent.serialCode = '';
    this.FacilityLocksComponent.unlockCode = '';
    this.FacilityLocksComponent.lockStatus = '';
    this.FacilityLocksComponent.unitId = item.UnitID;
    this.isNotification = true;
    this.FacilityLocksComponent.openModalPopup();
  }


  getNotificationSettingsByUser() {
    this.notificationService.getNotificationSettingsByUser().subscribe((response: INotificationSettings) => {
      if (response) {
        this.notificationAlertTimer = response.NotificationAlertTimer;        
        this.notificationSettingsOption = response.Options;
        this.notificationSettingsId = response.NotificationSettingId;
        this.hasSettingsAssigned = this.notificationSettingsId > 0;
        this.hasOptions = this.notificationSettingsOption && this.notificationSettingsOption.length;
        this.callNotificationHub(this.lastAccessedFacility)
      }
    });
  }

  isNotificationAssigned(option) {
    // Call center user with no notification settings
    if (this.isCallCenterGroup && !this.hasSettingsAssigned) {
      return option === this.ENotificationOptions.Tasks ||
        option === this.ENotificationOptions.FollowUp;
    }

    // Settings assigned but option not present
    if (this.hasSettingsAssigned && (!this.hasOptions ||
      this.notificationSettingsOption.findIndex(ele => ele.OptionId == option) === -1)) {
      return false;
    }

    switch (option) {
      case this.ENotificationOptions.Approvals:
        if (this.isSMAllStores) {
          return false;
        } else {
          return true;
        }
      case this.ENotificationOptions.AuctionEligibleUnits:
        if (!this.isDMAnyStore) {
          return false;
        } else {
          return true;
        }
      case this.ENotificationOptions.AutoCreditCardDeclines:
        if (!this.facilityDayendSetting || !this.facilityDayendSetting.DeclinedAutoCCNotification) {
          return false;
        } else {
          return true;
        }
    }
    return true;
  }

  getNotificationExpiredProofOfPP(facId) {
    this.loader_noti = Promise.resolve(true);
    this.notificationService.GetExpiredProofOfPPNotification(facId).subscribe((response: any) => {
      this.getNotificationExpiredProofOfPPsData = response;
      this.NotificationList = false;
      this.NotificationExpiredProofOfPPList = true;
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }

  HideNotificationExpiredProofofPP() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationExpiredProofOfPPList = false;
  }
  getNotificationPendingRemotePayments(facId,isToaster?) {
    const pagecount = this.pageNumber;
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.NotificationRemovedfromPendingRemotePaymentsList = true;
    this.notificationService.GetPendingRemotePayment(facId).subscribe((response: any) => {
      this.generalService.getNotificationRemovedFromPendingRemotePaymentscount = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      if (this.generalService.getNotificationRemovedFromPendingRemotePaymentscount.length === 0) {
        this.NotificationRemovedfromPendingRemotePaymentsList = false;
        this.NotificationList = true;
      }

      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }
  HideNotificationPendingRemotePayments() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationRemovedfromPendingRemotePaymentsList = false;
    this.generalService.NotificationAlert=true;
  }

  getNotificationRemovedFromAuction(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.notificationService.GetRemovedFromAuctionNotification(facId).subscribe((response: any) => {
      this.generalService.getNotificationRemovedFromAuctionData = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.NotificationList = false;
      this.NotificationRemovedFromAuctionList = true;
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }
   HideNotificationScheduledForAuction() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationScheduledForAuctionList = false;
     this.generalService.NotificationAlert=true;
  }

  hideNotificationDeclinedACHPayments() {
    this.NotificationList = true;
    this.notificationDeclinedACHPayments = false;
    this.generalService.NotificationAlert=true;
  }

  hideNotificationPendingBankResponseForAch() {
    this.NotificationList = true;
    this.notificationPendingBankResponseForAch = false;
    this.generalService.NotificationAlert = true;
  }

  getNotificationDeclinedACHPayments(facId, isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.notificationService.GetDeclinedACHPayments(facId).subscribe((response: IDeclinedACHPaymentNotification[]) => {
      this.notificationDeclinedACHPayments = true;
      this.generalService.getNotificationDeclinedACHPaymentsObj = response.map((rec: IDeclinedACHPaymentNotification) => {
        return {
          ...rec,
          TransactionDate: this.commonMethodService.getAPIDateTimeToLocalDatePart(rec.TransactionDate),
          ReversedOn: rec.ReversedOn ? this.commonMethodService.getAPIDateTimeToLocalDatePart(rec.ReversedOn) : null
        };
      });
       if (isToaster) {
        this.loader_noti = Promise.resolve(false);
         this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }
  getNotificationScheduledForAuction(facId,isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.notificationService.GetScheduledForAuctionNotification(facId).subscribe((response: any) => {
      this.generalService.getNotificationScheduledForAuctionData = response;
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.NotificationList = false;
      this.NotificationScheduledForAuctionList = true;
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }
  HideNotificationRemovedFromAuction() {
    this.pageNumber = 0;
    this.NotificationList = true;
    this.NotificationRemovedFromAuctionList = false;
     this.generalService.NotificationAlert=true;
  }

  getNotificationPendingBankResponseForAch(facId, isToaster?) {
    this.loader_noti = Promise.resolve(true);
    this.NotificationList = false;
    this.notificationService.GetPendingBankResponseForAch(facId).subscribe((response: IPendingBankResponseForAchNotification[]) => {
      this.notificationPendingBankResponseForAch = true;
      this.generalService.getNotificationPendingBankResponseForAchObj = response.map((rec: IPendingBankResponseForAchNotification) => {
        return {
          ...rec,
          TransactionDate: this.commonMethodService.getAPIDateTimeToLocalDatePart(rec.TransactionDate)
        };
      });
      if (isToaster) {
        this.loader_noti = Promise.resolve(false);
        this.showNotifications()
      }
      this.loader_noti = Promise.resolve(false);
    }, err => {
      this.loader_noti = Promise.resolve(false);
    });
  }
  routeOrDoNothing(details) {
    if (details.CustomerName != 'Walk in') {
      this.routeToRefundReversalOrLedger(details, this.getNotificationApprovalsObj.CategoryType, true);
    }
  }

  getTotalCount() {
    let totalCount = 0;

     if (!this.hasSettingsAssigned) {
      if (this.isCallCenterGroup) {
        totalCount = this.getEachCount(this.ENotificationOptions.FollowUp) + this.getEachCount(this.ENotificationOptions.Tasks);
      } else {
        totalCount = this.getAllCount();
      }

      return totalCount;
    }

    if (!this.hasOptions) {
      return 0;
    }

    this.notificationSettingsOption.forEach((ele) => {
      totalCount += this.getEachCount(ele.OptionId);
    });

    return totalCount;
  }

  getAllCount() {
    let sum = 0;
    for (const key in this.getNotificationCountObj) {
      if (key !== 'TotalCount' && typeof this.getNotificationCountObj[key] === 'number') {
        sum += this.getNotificationCountObj[key];
      }
    }
    return sum;
  }

  getEachCount(option) {
    switch (option) {
      case this.ENotificationOptions.Approvals:
        if (!this.isSMAllStores) {
          return this.getNotificationCountObj.Approvals;
        } else {
          return 0;
        }
      case this.ENotificationOptions.FollowUp:
        return this.getNotificationCountObj.FollowUpCount;
      case this.ENotificationOptions.Tasks:
        return this.getNotificationCountObj.Tasks;
      case this.ENotificationOptions.ScheduleMoveIn:
        return this.getNotificationCountObj.ScheduledMoveInsCount;
      case this.ENotificationOptions.ScheduleMoveOut:
        return this.getNotificationCountObj.ScheduledMoveoutCount;
      case this.ENotificationOptions.AuctionEligibleUnits:
        if (this.isDMAnyStore) {
          return this.getNotificationCountObj.AuctionEligibleUnits;
        } else {
          return 0;
        }
      case this.ENotificationOptions.UnitsToBeLocked:
        return this.getNotificationCountObj.UnitsToBeLockedCount;
      case this.ENotificationOptions.UnitsToBeUnLocked:
        return this.getNotificationCountObj.UnitsToBeUnLockedCount;
      case this.ENotificationOptions.AutoCreditCardDeclines:
        if (this.facilityDayendSetting && this.facilityDayendSetting.DeclinedAutoCCNotification) {
          return this.getNotificationCountObj.AutoCreditCardDeclineCount;
        } else {
          return 0;
        }
      case this.ENotificationOptions.InventoryReorder:
        return this.getNotificationCountObj.InventoryReorderCount;
      case this.ENotificationOptions.OnlineRentals:
        return this.getNotificationCountObj.OnlineRentalsCount;
      case this.ENotificationOptions.OnlinePayments:
        return this.getNotificationCountObj.OnlinePaymentsCount;
      case this.ENotificationOptions.OnlineReservations:
        return this.getNotificationCountObj.OnlineReservationsCount;
      case this.ENotificationOptions.OnlineInquiries:
        return this.getNotificationCountObj.OnlineInquiriesCount;
      case this.ENotificationOptions.RentRaiseAlerts:
        return this.getNotificationCountObj.RentRaiseBatch;
      case this.ENotificationOptions.CallCenterAlerts:
        return this.getNotificationCountObj.CallCenterAlertsCount;
      case this.ENotificationOptions.DayEndLettersInvoices:
        return this.getNotificationCountObj.DayEndLettersNInvoicesCount;
      case this.ENotificationOptions.DayEndReports:
        return this.getNotificationCountObj.DayEndReportsCount;
      case this.ENotificationOptions.FileReadyToDownload:
        return this.getNotificationCountObj.FileExportsCount;
      case this.ENotificationOptions.MailhouseErrors:
        return this.getNotificationCountObj.MailHouseErrors;
      case this.ENotificationOptions.ScheduledReports:
        return this.getNotificationCountObj.ScheduleReportsCount;
      case this.ENotificationOptions.ExpiredProofOfPP:
        return this.getNotificationCountObj.ExpiredProofofPropertyProtectionCount;
      case this.ENotificationOptions.UnitsRemovedFromAuction:
        return this.getNotificationCountObj.UnitsRemovedfromAuction;
      case this.ENotificationOptions.PendingRemotePayments:
        return this.getNotificationCountObj.PendingRemotePayPayment;
      case this.ENotificationOptions['Declined ACH/EFT Payments']:
        return this.getNotificationCountObj.DeclinedACHPayments
      case this.ENotificationOptions.UnitsScheduledForAuction:
        return this.getNotificationCountObj.UnitsScheduledForAuction
      case this.ENotificationOptions.PendingBankResponseForAch:
        return this.getNotificationCountObj.PendingBankResponseForAch;
    }
  }
  callNotificationHub(facilityId) {
    this.IsLicenseAndDavinciExist();
    if (!this.notificationService.isConnectedTo(facilityId)) {
      this.notificationService.stopConnection();

      if (this.notificationSub) {
        this.notificationSub.unsubscribe();
      }
      if(this.notificationToaster){
        this.notificationToaster.unsubscribe();
      }
      if (this.competitorSyncCompleteSub) {
        this.competitorSyncCompleteSub.unsubscribe();
      }
      this.notificationService.startConnection(this.baseURL, facilityId);
    }
    this.notificationSub = this.notificationService.notificationCount$
      .subscribe(({ facilityId: incomingFacilityId, model }) => {
        this.getNotificationCountObj = JSON.parse(model);
        this.getNotificationCount(incomingFacilityId);
      });
    this.notificationToaster = this.notificationService.notificationToaster$
      .subscribe(({ popupData,facilityId: incomingFacilityId, userId, usergroupId, facilitylist }) => {
        this.NotificationAlert = ENotificationOptions[popupData];

        if (popupData == ENotificationOptions.Tasks) {
          if (userId == this.userSessionService.userSessionData.UserId) {
            this.AlertNewNotifications(popupData);
          }
        } else if (popupData == ENotificationOptions.FollowUp) {
          if(!(this.isCallCenterGroup || incomingFacilityId == this.lastAccessedFacility)) {
            return;
          }
          const currentUserId = this.userSessionService.userSessionData.UserId;              
          if (((userId && userId == currentUserId))
            || ((usergroupId && facilitylist?.some((user: any) => user.Id === currentUserId)))
            || (!userId && !usergroupId && incomingFacilityId == this.lastAccessedFacility)) {
            this.AlertNewNotifications(popupData);
          }
        } else if (popupData == ENotificationOptions.Approvals) {
          if (this.notificationSettingsOption.findIndex((ele) => ele.OptionId == ENotificationOptions.Approvals) !== -1 && !this.isSMAllStores && (userId==null && this.isDMAnyStore)  && this.loggedinUserStoreGroups.some(group =>group.StorageFacilities?.some(facility => facility.Id === incomingFacilityId))) {
            this.AlertNewNotifications(popupData);
          } else if (this.notificationSettingsOption.findIndex((ele) => ele.OptionId == ENotificationOptions.Approvals) !== -1 && !this.isSMAllStores && (userId && this.isRMstore) && this.loggedinUserStoreGroups.some(group => group.StorageFacilities?.some(facility => facility.Id === incomingFacilityId))) {
            this.AlertNewNotifications(popupData);
          }
        }
        else if(popupData == ENotificationOptions.AuctionEligibleUnits){
          if(this.notificationSettingsOption.findIndex((ele) => ele.OptionId == ENotificationOptions.AuctionEligibleUnits) !== -1 && this.isDMAnyStore && this.userSessionService.userSessionData.StorageFacilities.some(x=>x.Id==incomingFacilityId)){
            this.AlertNewNotifications(popupData);
          }
        }
        else {
          if(incomingFacilityId==this.lastAccessedFacility){
            this.AlertNewNotifications(popupData);
          }

        }

      });
    this.competitorSyncCompleteSub?.unsubscribe();
    this.competitorSyncCompleteSub = this.notificationService.competitorSyncComplete$
      .subscribe(() => {
        this.toastr.info('Sync is completed.', 'Competitor Sync', {
          ...this.toasterConfig,
          closeButton: true
        });
      });

    if (!this.getNotificationCountObj) {
      this.getNotificationCountObj = this.generalService.MastergetNotificationCountObj
    }
    this.getNotificationCount(facilityId);
  }

  AlertNewNotifications(popupData) {
    if (this.notificationSettingsOption && this.generalService.IsAdmin === false) {
      const retainSeconds = this.notificationAlertTimer ?? 5;
      const timeOutMs = retainSeconds > 0 ? retainSeconds * 1000 : 0;

      const dynamicConfig = {
        ...this.toasterConfig,
        timeOut: timeOutMs,
        extendedTimeOut: timeOutMs,
        closeButton: true,
        enableHtml: true
      };
      const activeSubcountIds = this.notificationSettingsOption
        .filter(setting => setting.NotificationAlert)
        .map(alert => ({
          NotificationName: alert.NotificationName,
          OptionId: alert.OptionId
        }));

      this.finalAlertsList = activeSubcountIds
        .filter(x => x.OptionId === popupData)
        .map(x => ({
          NotificationName: x.NotificationName
        }));

      if (this.finalAlertsList && this.finalAlertsList.length > 0) {
        this.finalAlertsList.forEach(alert => {
          const messageHtml = `<div style="color: white;">
                              <strong>New ${alert.NotificationName}</strong> added
                              <hr class="m-0">
                              <div style="height: 2px; background-color: white; margin: 8px 0;"></div>
                                  <span id="showDetailsLink-${alert.Id}" style="color: white; cursor: pointer; user-select: none; display: inline-block;">
                              &#9654; Show Details
                              </span>
                              </div>`;

          const toast = this.toastr.info(messageHtml, 'Alert', dynamicConfig);

          if (toast?.toastId != null) {
            this.toastAlertMap.set(toast.toastId, alert);

            toast.onTap?.subscribe(() => {
              const matchingAlert = this.toastAlertMap.get(toast.toastId);
              if (matchingAlert) {
                window.onbeforeunload = null;
                this.handleNotificationClick(popupData);
              }
            });
          }
        });
      }
    }
    else {
      return null;
    }
  }

  handleNotificationClick(popupData: any) {
  this.generalService.NotificationAlert =false;
    this.displayNotificationList();
    this.clearDataObjects();
    switch (popupData) {
      case ENotificationOptions.ScheduleMoveOut:
        this.getNotificationScheduledMoveOut(this.lastAccessedFacility, true);
        break;
      case ENotificationOptions.ScheduleMoveIn:
       this.getNotificationSchMoveIns(this.lastAccessedFacility,true); 
        break;
      case ENotificationOptions.FollowUp:
      this.getNotificationFollowups(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.CallCenterAlerts:
     this.getNotificationCallCenterAlerts(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.RentRaiseAlerts:
      this.getNotificationRentRaiseAlt(this.lastAccessedFacility,true)
        break;
      case ENotificationOptions.Tasks:
       this.getNotificationTask(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.OnlineRentals:
       this.getNotificationOnRentals(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.OnlinePayments:
       this.getNotificationOnlinePayment(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.OnlineReservations:
       this.getNotificationOnlineReservation(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.OnlineInquiries:
       this.getNotificationOnlineInquiries(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.Approvals:
        this.GetApprovalCount(true);
        break;
      case ENotificationOptions.UnitsToBeLocked:
      this.getNotificationUnitsLocked(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.UnitsToBeUnLocked:
       this.getNotificationUnitsUnLocked(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.MailhouseErrors:
      this.getNotificationMailhouse(this.lastAccessedFacility,true);
        break;
    case  ENotificationOptions.PendingRemotePayments:
      this.getNotificationPendingRemotePayments(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.ScheduledReports:
       this.getNotificationScheduledReports(this.lastAccessedFacility,true)
        break;
      case ENotificationOptions.AutoCreditCardDeclines:
      this.getNotificationAutoCreditCardDecline(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.DayEndLettersInvoices:
      this.getNotificationDayEndTenantLettersAndNoticesByDate(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.DayEndReports:
      this.getNotificationDayEndReportsByDate(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.UnitsRemovedFromAuction:
      this.getNotificationRemovedFromAuction(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.FileReadyToDownload:
      this.getNotificationFileExport(this.lastAccessedFacility,true);
        break;
      case ENotificationOptions.AuctionEligibleUnits:
        this.AuctionApprovalsForFacilities(true);
        break;
      case ENotificationOptions.InventoryReorder:
      this.getNotificationInventoryReorder(this.lastAccessedFacility,true);
      break;
    case ENotificationOptions['Declined ACH/EFT Payments']:
      this.getNotificationDeclinedACHPayments(this.lastAccessedFacility,true);
      break;
    case ENotificationOptions.UnitsScheduledForAuction:
      this.getNotificationScheduledForAuction(this.lastAccessedFacility,true);
      break;
    case ENotificationOptions.PendingBankResponseForAch:
      this.getNotificationPendingBankResponseForAch(this.lastAccessedFacility, true);
      break;
    default:
      console.log('Unknown notification type');
      break;

  }
}
showNotifications() {
  const topHeader = document.querySelector('.topHearder') as HTMLElement;
  const notification = document.querySelector('.head_notification') as HTMLElement;
  const container = document.querySelector('.containerForRemoveNotify') as HTMLElement;

  if (!topHeader || !container) {
    return;
  }

    if (!container.classList.contains('Open')) {
      topHeader.classList.add('notification_toggle');
      notification?.classList.add('selected');
      container.classList.add('Open');
    }

    topHeader.classList.remove('message_toggle');
    topHeader.classList.remove('profile_toggle');

    if (this.lastAccessedFacility != 0 && !this.isAdmin) {
      document.querySelector('.head_msg')?.classList.remove('selected');
    }
}

  getPendingACHMessage(status: number | null): string {
    return this.pendingACHStatusMap[status ?? -1];
  }
}
